import { useEffect, useState } from 'react';
import { Accordion, Alert, Form, FormCheck } from 'react-bootstrap';
import parse from "html-react-parser";
import { registerNlpStart } from '../../utils/utils';
import { useTranslation } from 'react-i18next';

export interface AnalyzedTextProps {
    task_id: string;
    analyzedText: any;
    saveFormattedTextCallback: CallableFunction;
    language?: string;
}

const emptyVerbTensOptions = {
    Present_Simple: false,
    Present_Continuous: false,
    Present_Perfect: false,
    Present_Perfect_Continuous: false,
    Past_Simple: false,
    Past_Continuous: false,
    Past_Perfect: false,
    Past_Perfect_Continuous: false,
    Future_Be_Going_To: false,
    Future_Simple: false,
    Future_Perfect: false,
    Future_Perfect_Continuous: false,
    Present_Simple_Passive: false,
    Present_Continuous_Passive: false,
    Present_Perfect_Passive: false,
    Present_Perfect_Continuous_Passive: false,
    Past_Simple_Passive: false,
    Past_Continuous_Passive: false,
    Past_Perfect_Passive: false,
    Past_Perfect_Continuous_Passive: false,
    Future_Simple_Passive: false,
    Future_Perfect_Passive: false
};

export default function AnalyzedTextRussian(props: AnalyzedTextProps) {
    const { t } = useTranslation();

    console.log('props.analyzedText', props.analyzedText);

    const [allText, setAllText] = useState('');
    const [processingEmpty, setProcessingEmpty] = useState(false);

    const [nlpCategories, setNlpCategories] = useState<any>({});
    const [pragmaticsFilterActive, setPragmaticsFilterActive] = useState(false);
    const [pragmaticsFilterOption, setPragmaticsFilterOption] = useState('all');
    const [pragmaticsColor, setPragmaticColor] = useState('');
    const [pragmaticsSize, setPragmaticSize] = useState('');
    const [pragmaticsBold, setPragmaticBold] = useState(false);
    const [pragmaticsItalic, setPragmaticItalic] = useState(false);
    const [pragmaticsUnderline, setPragmaticUnderline] = useState(false);

    const [phrasalVerbsFilterActive, setPhrasalVerbsFilterActive] = useState(false);
    // const [phrasalVerbsFilterOption, setPhrasalVerbsFilterOption] = useState('all');
    const [phrasalVerbsColor, setPhrasalVerbsColor] = useState('');
    const [phrasalVerbsSize, setPhrasalVerbsSize] = useState('');
    const [phrasalVerbsBold, setPhrasalVerbsBold] = useState(false);
    const [phrasalVerbsItalic, setPhrasalVerbsItalic] = useState(false);
    const [phrasalVerbsUnderline, setPhrasalVerbsUnderline] = useState(false);
    
    const [nounsFilterActive, setNounsFilterActive] = useState(false);
    const [nounsFilterOption, setNounsFilterOption] = useState('all');
    const [nounsColor, setNounsColor] = useState('');
    const [nounsSize, setNounsSize] = useState('');
    const [nounsBold, setNounsBold] = useState(false);
    const [nounsItalic, setNounsItalic] = useState(false);
    const [nounsUnderline, setNounsUnderline] = useState(false);
    // Nouns subcategory checkboxes
    const [nounsGenderChecked, setNounsGenderChecked] = useState({ fem: false, masc: false, neut: false });
    const [nounsAnimacyChecked, setNounsAnimacyChecked] = useState({ anim: false, inan: false });
    const [nounsNumberChecked, setNounsNumberChecked] = useState({ sing: false, plur: false });
    const [nounsCaseChecked, setNounsCaseChecked] = useState({ nom: false, gen: false, acc: false, dat: false, ins: false, loc: false });

    const [properNounsFilterActive, setProperNounsFilterActive] = useState(false);
    const [properNounsFilterOption, setProperNounsFilterOption] = useState('all');
    const [properNounsColor, setProperNounsColor] = useState('');
    const [properNounsSize, setProperNounsSize] = useState('');
    const [properNounsBold, setProperNounsBold] = useState(false);
    const [properNounsItalic, setProperNounsItalic] = useState(false);
    const [properNounsUnderline, setProperNounsUnderline] = useState(false);
    // Proper Nouns subcategory checkboxes
    const [properNounsGenderChecked, setProperNounsGenderChecked] = useState({ fem: false, masc: false, neut: false });
    const [properNounsAnimacyChecked, setProperNounsAnimacyChecked] = useState({ anim: false, inan: false });
    const [properNounsNumberChecked, setProperNounsNumberChecked] = useState({ sing: false, plur: false });
    const [properNounsCaseChecked, setProperNounsCaseChecked] = useState({ nom: false, gen: false, acc: false, dat: false, ins: false, loc: false });

    const [numeralsFilterActive, setNumeralsFilterActive] = useState(false);
    const [numeralsFilterOption, setNumeralsFilterOption] = useState('all');
    const [numeralsColor, setNumeralsColor] = useState('');
    const [numeralsSize, setNumeralsSize] = useState('');
    const [numeralsBold, setNumeralsBold] = useState(false);
    const [numeralsItalic, setNumeralsItalic] = useState(false);
    const [numeralsUnderline, setNumeralsUnderline] = useState(false);
    // Numerals subcategory checkboxes
    const [numeralsGenderChecked, setNumeralsGenderChecked] = useState({ fem: false, masc: false, neut: false });
    const [numeralsNumberChecked, setNumeralsNumberChecked] = useState({ sing: false, plur: false });
    const [numeralsCaseChecked, setNumeralsCaseChecked] = useState({ nom: false, gen: false, acc: false, dat: false, ins: false, loc: false });
    const [numeralsNumTypeChecked, setNumeralsNumTypeChecked] = useState({ card: false });

    const [adjectivesFilterActive, setAdjectivesFilterActive] = useState(false);
    const [adjectivesFilterOption, setAdjectivesFilterOption] = useState('all');
    const [adjectivesColor, setAdjectivesColor] = useState('');
    const [adjectivesSize, setAdjectivesSize] = useState('');
    const [adjectivesBold, setAdjectivesBold] = useState(false);
    const [adjectivesItalic, setAdjectivesItalic] = useState(false);
    const [adjectivesUnderline, setAdjectivesUnderline] = useState(false);
    // Adjectives subcategory checkboxes
    const [adjectivesGenderChecked, setAdjectivesGenderChecked] = useState({ fem: false, masc: false, neut: false });
    const [adjectivesAnimacyChecked, setAdjectivesAnimacyChecked] = useState({ anim: false, inan: false });
    const [adjectivesNumberChecked, setAdjectivesNumberChecked] = useState({ sing: false, plur: false });
    const [adjectivesCaseChecked, setAdjectivesCaseChecked] = useState({ nom: false, gen: false, acc: false, dat: false, ins: false, loc: false });
    const [adjectivesDegreeChecked, setAdjectivesDegreeChecked] = useState({ pos: false, cmp: false, sup: false });
    const [adjectivesFormChecked, setAdjectivesFormChecked] = useState({ short: false });

    const [adverbsFilterActive, setAdverbsFilterActive] = useState(false);
    const [adverbsFilterOption, setAdverbsFilterOption] = useState('all');
    const [adverbsColor, setAdverbsColor] = useState('');
    const [adverbsSize, setAdverbsSize] = useState('');
    const [adverbsBold, setAdverbsBold] = useState(false);
    const [adverbsItalic, setAdverbsItalic] = useState(false);
    const [adverbsUnderline, setAdverbsUnderline] = useState(false);
    const [adverbsDegreeChecked, setAdverbsDegreeChecked] = useState({ cmp: false, sup: false });

    const [verbsFilterActive, setVerbsFilterActive] = useState(false);
    const [verbsFilterOption, setVerbsFilterOption] = useState('all');
    const [verbsColor, setVerbsColor] = useState('');
    const [verbsSize, setVerbsSize] = useState('');
    const [verbsBold, setVerbsBold] = useState(false);
    const [verbsItalic, setVerbsItalic] = useState(false);
    const [verbsUnderline, setVerbsUnderline] = useState(false);
    const [verbsAspectChecked, setVerbsAspectChecked] = useState({ imp: false, perf: false });
    const [verbsTenseChecked, setVerbsTenseChecked] = useState({ past: false, pres: false, fut: false });
    const [verbsMoodChecked, setVerbsMoodChecked] = useState({ ind: false, cnd: false, imp: false });
    const [verbsGenderChecked, setVerbsGenderChecked] = useState({ fem: false, masc: false, neut: false });
    const [verbsNumberChecked, setVerbsNumberChecked] = useState({ sing: false, plur: false });
    const [verbsPersonChecked, setVerbsPersonChecked] = useState({ first: false, second: false, third: false });
    const [verbsVerbFormChecked, setVerbsVerbFormChecked] = useState({ fin: false, inf: false, conv: false, part: false });
    const [verbsVoiceChecked, setVerbsVoiceChecked] = useState({ act: false, mid: false, pass: false });
    const [verbTenseOptions, setVerbTensOptions] = useState(emptyVerbTensOptions);

    const [prepositionsFilterActive, setPrepositionsFilterActive] = useState(false);
    const [prepositionsFilterOption, setPrepositionsFilterOption] = useState('all');
    const [prepositionsColor, setPrepositionsColor] = useState('');
    const [prepositionsSize, setPrepositionsSize] = useState('');
    const [prepositionsBold, setPrepositionsBold] = useState(false);
    const [prepositionsItalic, setPrepositionsItalic] = useState(false);
    const [prepositionsUnderline, setPrepositionsUnderline] = useState(false);

    const [subConjunctionsFilterActive, setSubConjunctionsFilterActive] = useState(false);
    const [subConjunctionsFilterOption, setSubConjunctionsFilterOption] = useState('all');
    const [subConjunctionsColor, setSubConjunctionsColor] = useState('');
    const [subConjunctionsSize, setSubConjunctionsSize] = useState('');
    const [subConjunctionsBold, setSubConjunctionsBold] = useState(false);
    const [subConjunctionsItalic, setSubConjunctionsItalic] = useState(false);
    const [subConjunctionsUnderline, setSubConjunctionsUnderline] = useState(false);

    const [determinersFilterActive, setDeterminersFilterActive] = useState(false);
    const [determinersFilterOption, setDeterminersFilterOption] = useState('all');
    const [determinersColor, setDeterminersColor] = useState('');
    const [determinersSize, setDeterminersSize] = useState('');
    const [determinersBold, setDeterminersBold] = useState(false);
    const [determinersItalic, setDeterminersItalic] = useState(false);
    const [determinersUnderline, setDeterminersUnderline] = useState(false);

    const [pronounsFilterActive, setPronounsFilterActive] = useState(false);
    const [pronounsFilterOption, setPronounsFilterOption] = useState('all');
    const [pronounsColor, setPronounsColor] = useState('');
    const [pronounsSize, setPronounsSize] = useState('');
    const [pronounsBold, setPronounsBold] = useState(false);
    const [pronounsItalic, setPronounsItalic] = useState(false);
    const [pronounsUnderline, setPronounsUnderline] = useState(false);
    const [pronounsGenderChecked, setPronounsGenderChecked] = useState({ fem: false, masc: false, neut: false });
    const [pronounsAnimacyChecked, setPronounsAnimacyChecked] = useState({ anim: false, inan: false });
    const [pronounsNumberChecked, setPronounsNumberChecked] = useState({ sing: false, plur: false });
    const [pronounsCaseChecked, setPronounsCaseChecked] = useState({ nom: false, gen: false, acc: false, dat: false, ins: false, loc: false });
    const [pronounsPersonChecked, setPronounsPersonChecked] = useState({ first: false, second: false, third: false });
    const [pronounsPronTypeChecked, setPronounsPronTypeChecked] = useState({ prs: false, ind: false, dem: false });

    const [conjunctionsFilterActive, setConjunctionsFilterActive] = useState(false);
    const [conjunctionsFilterOption, setConjunctionsFilterOption] = useState('all');
    const [conjunctionsColor, setConjunctionsColor] = useState('');
    const [conjunctionsSize, setConjunctionsSize] = useState('');
    const [conjunctionsBold, setConjunctionsBold] = useState(false);
    const [conjunctionsItalic, setConjunctionsItalic] = useState(false);
    const [conjunctionsUnderline, setConjunctionsUnderline] = useState(false);

    const [particlesFilterActive, setParticlesFilterActive] = useState(false);
    const [particlesFilterOption, setParticlesFilterOption] = useState('all');
    const [particlesColor, setParticlesColor] = useState('');
    const [particlesSize, setParticlesSize] = useState('');
    const [particlesBold, setParticlesBold] = useState(false);
    const [particlesItalic, setParticlesItalic] = useState(false);
    const [particlesUnderline, setParticlesUnderline] = useState(false);

    const handleChangePragmaticExpressions = (event: any) => {
        setPragmaticsFilterActive(event.target.checked);
        setPragmaticsFilterOption('all');
        setPragmaticColor('');
        setPragmaticSize('');
        setPragmaticBold(false);
        setPragmaticItalic(false);
        setPragmaticUnderline(false);
        setPhrasalVerbsFilterActive(false);
        // setPhrasalVerbsFilterOption('');
        setPhrasalVerbsColor('');
        setPhrasalVerbsSize('');
        setPhrasalVerbsBold(false);
        setPhrasalVerbsItalic(false);
        setPhrasalVerbsUnderline(false);
        setNounsFilterActive(false);
        setNounsColor('');
        setNounsSize('');
        setNounsBold(false);
        setNounsItalic(false);
        setNounsUnderline(false);
        setAdjectivesFilterActive(false);
        setAdjectivesColor('');
        setAdjectivesSize('');
        setAdjectivesBold(false);
        setAdjectivesItalic(false);
        setAdjectivesUnderline(false);
        setAdverbsFilterActive(false);
        setAdverbsColor('');
        setAdverbsSize('');
        setAdverbsBold(false);
        setAdverbsItalic(false);
        setAdverbsUnderline(false);
        setVerbsFilterActive(false);
        setVerbsColor('');
        setVerbsSize('');
        setVerbsBold(false);
        setVerbsItalic(false);
        setVerbsUnderline(false);
        setPrepositionsFilterActive(false);
        setPrepositionsColor('');
        setPrepositionsSize('');
        setPrepositionsBold(false);
        setPrepositionsItalic(false);
        setPrepositionsUnderline(false);
        setSubConjunctionsFilterActive(false);
        setSubConjunctionsColor('');
        setSubConjunctionsSize('');
        setSubConjunctionsBold(false);
        setSubConjunctionsItalic(false);
        setSubConjunctionsUnderline(false);
        setDeterminersFilterActive(false);
        setDeterminersColor('');
        setDeterminersSize('');
        setDeterminersBold(false);
        setDeterminersItalic(false);
        setDeterminersUnderline(false);
        setPronounsFilterActive(false);
        setPronounsColor('');
        setPronounsSize('');
        setPronounsBold(false);
        setPronounsItalic(false);
        setPronounsUnderline(false);
        setConjunctionsFilterActive(false);
        setConjunctionsColor('');
        setConjunctionsSize('');
        setConjunctionsBold(false);
        setConjunctionsItalic(false);
        setConjunctionsUnderline(false);
        formatText(props.analyzedText.main,
            event.target.checked, 'all', '', '', false, false, false,
            false, '', '', false, false, false,
            false,
            '', '', '', false, false, false,
            { fem: false, masc: false, neut: false }, { anim: false, inan: false }, { sing: false, plur: false }, { nom: false, gen: false, acc: false, dat: false, ins: false, loc: false },
            false,
            'all', '', '', false, false, false,
            { fem: false, masc: false, neut: false }, { anim: false, inan: false }, { sing: false, plur: false }, { nom: false, gen: false, acc: false, dat: false, ins: false, loc: false },
            false,
            'all', '', '', false, false, false,
            { fem: false, masc: false, neut: false }, { sing: false, plur: false }, { nom: false, gen: false, acc: false, dat: false, ins: false, loc: false }, { card: false },
            '', '', '', false, false, false,
            { cmp: false, sup: false },
            '', '', '', false, false, false,
            { cmp: false, sup: false },
            '', emptyVerbTensOptions, '', '', false, false, false,
            { impf: false, perf: false }, { past: false, pres: false, fut: false }, { ind: false, cnd: false, imp: false }, { fem: false, masc: false, neut: false }, { sing: false, plur: false }, { first: false, second: false, third: false }, { fin: false, inf: false, conv: false, part: false }, { act: false, mid: false, pass: false },
            '', '', '', false, false, false,
            '', '', '', false, false, false,
            '', '', '', false, false, false,
            '', '', '', false, false, false,
            { fem: false, masc: false, neut: false }, { anim: false, inan: false }, { sing: false, plur: false }, { nom: false, gen: false, acc: false, dat: false, ins: false, loc: false }, { first: false, second: false, third: false }, { prs: false, ind: false, dem: false },
            '', '', '', false, false, false,
            '', '', '', false, false, false);
    }

    const handlePragmaticsFilterOptionChange = (event) => {
        setPragmaticsFilterOption(event.target.value);
        registerNlpStart(props.task_id, 'Word Categories', 'Pragmatics', event.target.value);
        formatText(props.analyzedText.main,
            pragmaticsFilterActive, event.target.value, pragmaticsColor, pragmaticsSize, pragmaticsBold, pragmaticsItalic, pragmaticsUnderline,
            phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline,
            particlesFilterOption, particlesColor, particlesSize, particlesBold, particlesItalic, particlesUnderline);
    }

    const handleChangePhrasalVerbs = (event: any) => {
        registerNlpStart(props.task_id, 'Word Categories', 'PhrasalVerbs', '');
        setPragmaticsFilterActive(false);
        setPragmaticsFilterOption('');
        setPragmaticColor('');
        setPragmaticSize('');
        setPragmaticBold(false);
        setPragmaticItalic(false);
        setPragmaticUnderline(false);
        setPhrasalVerbsFilterActive(event.target.checked);
        //setPhrasalVerbsFilterOption('all');
        setPhrasalVerbsColor('');
        setPhrasalVerbsSize('');
        setPhrasalVerbsBold(false);
        setPhrasalVerbsItalic(false);
        setPhrasalVerbsUnderline(false);
        setNounsFilterActive(false);
        setNounsColor('');
        setNounsSize('');
        setNounsBold(false);
        setNounsItalic(false);
        setNounsUnderline(false);
        setAdjectivesFilterActive(false);
        setAdjectivesColor('');
        setAdjectivesSize('');
        setAdjectivesBold(false);
        setAdjectivesItalic(false);
        setAdjectivesUnderline(false);
        setAdverbsFilterActive(false);
        setAdverbsColor('');
        setAdverbsSize('');
        setAdverbsBold(false);
        setAdverbsItalic(false);
        setAdverbsUnderline(false);
        setVerbsFilterActive(false);
        setVerbsColor('');
        setVerbsSize('');
        setVerbsBold(false);
        setVerbsItalic(false);
        setVerbsUnderline(false);
        setPrepositionsFilterActive(false);
        setPrepositionsColor('');
        setPrepositionsSize('');
        setPrepositionsBold(false);
        setPrepositionsItalic(false);
        setPrepositionsUnderline(false);
        setSubConjunctionsFilterActive(false);
        setSubConjunctionsColor('');
        setSubConjunctionsSize('');
        setSubConjunctionsBold(false);
        setSubConjunctionsItalic(false);
        setSubConjunctionsUnderline(false);
        setDeterminersFilterActive(false);
        setDeterminersColor('');
        setDeterminersSize('');
        setDeterminersBold(false);
        setDeterminersItalic(false);
        setDeterminersUnderline(false);
        setPronounsFilterActive(false);
        setPronounsColor('');
        setPronounsSize('');
        setPronounsBold(false);
        setPronounsItalic(false);
        setPronounsUnderline(false);
        setConjunctionsFilterActive(false);
        setConjunctionsColor('');
        setConjunctionsSize('');
        setConjunctionsBold(false);
        setConjunctionsItalic(false);
        setConjunctionsUnderline(false);
        formatText(props.analyzedText.main,
            false, '', '', '', false, false, false,
            event.target.checked, '', '', false, false, false,
            false,
            '', '', '', false, false, false,
            { fem: false, masc: false, neut: false }, { anim: false, inan: false }, { sing: false, plur: false }, { nom: false, gen: false, acc: false, dat: false, ins: false, loc: false },
            false,
            '', '', '', false, false, false,
            { fem: false, masc: false, neut: false }, { anim: false, inan: false }, { sing: false, plur: false }, { nom: false, gen: false, acc: false, dat: false, ins: false, loc: false },
            false,
            'all', '', '', false, false, false,
            { fem: false, masc: false, neut: false }, { sing: false, plur: false }, { nom: false, gen: false, acc: false, dat: false, ins: false, loc: false }, { card: false },
            '', '', '', false, false, false,
            '', emptyVerbTensOptions, '', '', false, false, false,
            { fem: false, masc: false, neut: false }, { sing: false, plur: false }, { first: false, second: false, third: false }, { fin: false, inf: false, conv: false, part: false }, { act: false, mid: false, pass: false },
            '', '', '', false, false, false,
            '', '', '', false, false, false,
            '', '', '', false, false, false,
            '', '', '', false, false, false,
            '', '', '', false, false, false);
    }

    const handleNounsFilterChange = (event) => {
        setPragmaticsFilterActive(false);
        setPragmaticsFilterOption('all');
        setPragmaticColor('');
        setPragmaticSize('');
        setPragmaticBold(false);
        setPragmaticItalic(false);
        setPragmaticUnderline(false);
        setPhrasalVerbsFilterActive(false);
        // setPhrasalVerbsFilterOption('all');
        setPhrasalVerbsColor('');
        setPhrasalVerbsSize('');
        setPhrasalVerbsBold(false);
        setPhrasalVerbsItalic(false);
        setPhrasalVerbsUnderline(false);
        setNounsColor('');
        setNounsSize('');
        setNounsBold(false);
        setNounsItalic(false);
        setNounsUnderline(false);
        setNounsFilterActive(event.target.checked);
        formatText(props.analyzedText.main,
            false, '', '', '', false, false, false,
            false, '', '', false, false, false,
            event.target.checked,
            'all', '', '', false, false, false,
            { fem: false, masc: false, neut: false }, { anim: false, inan: false }, { sing: false, plur: false }, { nom: false, gen: false, acc: false, dat: false, ins: false, loc: false },
            false,
            'all', '', '', false, false, false,
            { fem: false, masc: false, neut: false }, { anim: false, inan: false }, { sing: false, plur: false }, { nom: false, gen: false, acc: false, dat: false, ins: false, loc: false },
            false,
            'all', '', '', false, false, false,
            { fem: false, masc: false, neut: false }, { sing: false, plur: false }, { nom: false, gen: false, acc: false, dat: false, ins: false, loc: false }, { card: false },
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleNounsFilterOptionChange = (event) => {
        const id = event.target.id;
        const value = event.target.value;
        const checked = event.target.checked;
        const type = event.target.type;

        let newGenderChecked = nounsGenderChecked;
        let newAnimacyChecked = nounsAnimacyChecked;
        let newNumberChecked = nounsNumberChecked;
        let newCaseChecked = nounsCaseChecked;
        let newFilterOption = nounsFilterOption;

        // Handle radio button changes
        if (type === 'radio') {
            setNounsFilterOption(value);
            newFilterOption = value;
            registerNlpStart(props.task_id, 'Word Categories', 'Nouns', value);

            // Mark all checkboxes for the selected category
            if (value === 'gender') {
                newGenderChecked = { fem: true, masc: true, neut: true };
                setNounsGenderChecked(newGenderChecked);
            } else if (value === 'animacy') {
                newAnimacyChecked = { anim: true, inan: true };
                setNounsAnimacyChecked(newAnimacyChecked);
            } else if (value === 'number') {
                newNumberChecked = { sing: true, plur: true };
                setNounsNumberChecked(newNumberChecked);
            } else if (value === 'case') {
                newCaseChecked = { nom: true, gen: true, acc: true, dat: true, ins: true, loc: true };
                setNounsCaseChecked(newCaseChecked);
            }
        }
        // Handle checkbox changes
        else if (type === 'checkbox') {
            if (id.includes('nouns-gender-')) {
                const key = id.replace('nouns-gender-', '');
                newGenderChecked = { ...nounsGenderChecked, [key]: checked };
                setNounsGenderChecked(newGenderChecked);
            } else if (id.includes('nouns-animacy-')) {
                const key = id.replace('nouns-animacy-', '');
                newAnimacyChecked = { ...nounsAnimacyChecked, [key]: checked };
                setNounsAnimacyChecked(newAnimacyChecked);
            } else if (id.includes('nouns-number-')) {
                const key = id.replace('nouns-number-', '');
                newNumberChecked = { ...nounsNumberChecked, [key]: checked };
                setNounsNumberChecked(newNumberChecked);
            } else if (id.includes('nouns-case-')) {
                const key = id.replace('nouns-case-', '');
                newCaseChecked = { ...nounsCaseChecked, [key]: checked };
                setNounsCaseChecked(newCaseChecked);
            }
        }

        formatText(props.analyzedText.main,
            pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, pragmaticsSize, pragmaticsBold, pragmaticsItalic, pragmaticsUnderline,
            phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
            nounsFilterActive,
            newFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            newGenderChecked, newAnimacyChecked, newNumberChecked, newCaseChecked,
            false,
            'all', '', '', false, false, false,
            { fem: false, masc: false, neut: false }, { anim: false, inan: false }, { sing: false, plur: false }, { nom: false, gen: false, acc: false, dat: false, ins: false, loc: false },
            false,
            'all', '', '', false, false, false,
            { fem: false, masc: false, neut: false }, { sing: false, plur: false }, { nom: false, gen: false, acc: false, dat: false, ins: false, loc: false }, { card: false },
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleProperNounsFilterChange = (event) => {
        setPragmaticsFilterActive(false);
        setPragmaticsFilterOption('all');
        setPragmaticColor('');
        setPragmaticSize('');
        setPragmaticBold(false);
        setPragmaticItalic(false);
        setPragmaticUnderline(false);
        setPhrasalVerbsFilterActive(false);
        setPhrasalVerbsColor('');
        setPhrasalVerbsSize('');
        setPhrasalVerbsBold(false);
        setPhrasalVerbsItalic(false);
        setPhrasalVerbsUnderline(false);
        setProperNounsColor('');
        setProperNounsSize('');
        setProperNounsBold(false);
        setProperNounsItalic(false);
        setProperNounsUnderline(false);
        setProperNounsFilterActive(event.target.checked);
    }

    const handleProperNounsFilterOptionChange = (event) => {
        const id = event.target.id;
        const value = event.target.value;
        const checked = event.target.checked;
        const type = event.target.type;

        let newGenderChecked = properNounsGenderChecked;
        let newAnimacyChecked = properNounsAnimacyChecked;
        let newNumberChecked = properNounsNumberChecked;
        let newCaseChecked = properNounsCaseChecked;
        let newFilterOption = properNounsFilterOption;

        // Handle radio button changes
        if (type === 'radio') {
            setProperNounsFilterOption(value);
            newFilterOption = value;
            registerNlpStart(props.task_id, 'Word Categories', 'Proper Nouns', value);

            // Mark all checkboxes for the selected category
            if (value === 'gender') {
                newGenderChecked = { fem: true, masc: true, neut: true };
                setProperNounsGenderChecked(newGenderChecked);
            } else if (value === 'animacy') {
                newAnimacyChecked = { anim: true, inan: true };
                setProperNounsAnimacyChecked(newAnimacyChecked);
            } else if (value === 'number') {
                newNumberChecked = { sing: true, plur: true };
                setProperNounsNumberChecked(newNumberChecked);
            } else if (value === 'case') {
                newCaseChecked = { nom: true, gen: true, acc: true, dat: true, ins: true, loc: true };
                setProperNounsCaseChecked(newCaseChecked);
            }
        }
        // Handle checkbox changes
        else if (type === 'checkbox') {
            if (id.includes('propernouns-gender-')) {
                const key = id.replace('propernouns-gender-', '');
                newGenderChecked = { ...properNounsGenderChecked, [key]: checked };
                setProperNounsGenderChecked(newGenderChecked);
            } else if (id.includes('propernouns-animacy-')) {
                const key = id.replace('propernouns-animacy-', '');
                newAnimacyChecked = { ...properNounsAnimacyChecked, [key]: checked };
                setProperNounsAnimacyChecked(newAnimacyChecked);
            } else if (id.includes('propernouns-number-')) {
                const key = id.replace('propernouns-number-', '');
                newNumberChecked = { ...properNounsNumberChecked, [key]: checked };
                setProperNounsNumberChecked(newNumberChecked);
            } else if (id.includes('propernouns-case-')) {
                const key = id.replace('propernouns-case-', '');
                newCaseChecked = { ...properNounsCaseChecked, [key]: checked };
                setProperNounsCaseChecked(newCaseChecked);
            }
        }

        // Call formatText with proper nouns parameters
        formatText(props.analyzedText.main,
            pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, pragmaticsSize, pragmaticsBold, pragmaticsItalic, pragmaticsUnderline,
            phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            newFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            newGenderChecked, newAnimacyChecked, newNumberChecked, newCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleNumeralsFilterChange = (event) => {
        setPragmaticsFilterActive(false);
        setPragmaticsFilterOption('all');
        setPragmaticColor('');
        setPragmaticSize('');
        setPragmaticBold(false);
        setPragmaticItalic(false);
        setPragmaticUnderline(false);
        setPhrasalVerbsFilterActive(false);
        setPhrasalVerbsColor('');
        setPhrasalVerbsSize('');
        setPhrasalVerbsBold(false);
        setPhrasalVerbsItalic(false);
        setPhrasalVerbsUnderline(false);
        setNumeralsColor('');
        setNumeralsSize('');
        setNumeralsBold(false);
        setNumeralsItalic(false);
        setNumeralsUnderline(false);
        setNumeralsFilterActive(event.target.checked);
    }

    const handleNumeralsFilterOptionChange = (event) => {
        const id = event.target.id;
        const value = event.target.value;
        const checked = event.target.checked;
        const type = event.target.type;

        let newGenderChecked = numeralsGenderChecked;
        let newNumberChecked = numeralsNumberChecked;
        let newCaseChecked = numeralsCaseChecked;
        let newNumTypeChecked = numeralsNumTypeChecked;
        let newFilterOption = numeralsFilterOption;

        // Handle radio button changes
        if (type === 'radio') {
            setNumeralsFilterOption(value);
            newFilterOption = value;
            registerNlpStart(props.task_id, 'Word Categories', 'Numerals', value);

            // Mark all checkboxes for the selected category
            if (value === 'gender') {
                newGenderChecked = { fem: true, masc: true, neut: true };
                setNumeralsGenderChecked(newGenderChecked);
            } else if (value === 'number') {
                newNumberChecked = { sing: true, plur: true };
                setNumeralsNumberChecked(newNumberChecked);
            } else if (value === 'case') {
                newCaseChecked = { nom: true, gen: true, acc: true, dat: true, ins: true, loc: true };
                setNumeralsCaseChecked(newCaseChecked);
            } else if (value === 'numtype') {
                newNumTypeChecked = { card: true };
                setNumeralsNumTypeChecked(newNumTypeChecked);
            }
        }
        // Handle checkbox changes
        else if (type === 'checkbox') {
            if (id.includes('numerals-gender-')) {
                const key = id.replace('numerals-gender-', '');
                newGenderChecked = { ...numeralsGenderChecked, [key]: checked };
                setNumeralsGenderChecked(newGenderChecked);
            } else if (id.includes('numerals-number-')) {
                const key = id.replace('numerals-number-', '');
                newNumberChecked = { ...numeralsNumberChecked, [key]: checked };
                setNumeralsNumberChecked(newNumberChecked);
            } else if (id.includes('numerals-case-')) {
                const key = id.replace('numerals-case-', '');
                newCaseChecked = { ...numeralsCaseChecked, [key]: checked };
                setNumeralsCaseChecked(newCaseChecked);
            } else if (id.includes('numerals-numtype-')) {
                const key = id.replace('numerals-numtype-', '');
                newNumTypeChecked = { ...numeralsNumTypeChecked, [key]: checked };
                setNumeralsNumTypeChecked(newNumTypeChecked);
            }
        }

        // Call formatText with numerals parameters
        formatText(props.analyzedText.main,
            pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, pragmaticsSize, pragmaticsBold, pragmaticsItalic, pragmaticsUnderline,
            phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            newFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            newGenderChecked, newNumberChecked, newCaseChecked, newNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleAdjectivesFilterChange = (event) => {
        setPragmaticsFilterActive(false);
        setPragmaticsFilterOption('all');
        setPragmaticColor('');
        setPragmaticSize('');
        setPragmaticBold(false);
        setPragmaticItalic(false);
        setPragmaticUnderline(false);
        setPhrasalVerbsFilterActive(false);
        //setPhrasalVerbsFilterOption('all');
        setPhrasalVerbsColor('');
        setPhrasalVerbsSize('');
        setPhrasalVerbsBold(false);
        setPhrasalVerbsItalic(false);
        setPhrasalVerbsUnderline(false);
        setAdjectivesColor('');
        setAdjectivesSize('');
        setAdjectivesBold(false);
        setAdjectivesItalic(false);
        setAdjectivesUnderline(false);
        setAdjectivesFilterActive(event.target.checked);
        formatText(props.analyzedText.main,
            false, '', '', '', false, false, false,
            false, '', '', false, false, false,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            event.target.checked, 'all', '', '', false, false, false,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline,
            particlesFilterOption, particlesColor, particlesSize, particlesBold, particlesItalic, particlesUnderline);
    }

    const handleAdjectivesFilterOptionChange = (event) => {
       const type = event.target.type;
       const value = event.target.value;
       const id = event.target.id;
       const checked = event.target.checked;
       let newFilterOption = adjectivesFilterOption;
       let newGenderChecked = adjectivesGenderChecked;
       let newAnimacyChecked = adjectivesAnimacyChecked;
       let newNumberChecked = adjectivesNumberChecked;
       let newCaseChecked = adjectivesCaseChecked;
       let newDegreeChecked = adjectivesDegreeChecked;
       let newFormChecked = adjectivesFormChecked;

       // Only change filter option if it's a radio button, not a checkbox
       if (type === 'radio') {
           setAdjectivesFilterOption(value);
           registerNlpStart(props.task_id, 'Word Categories', 'Adjectives', value);
           newFilterOption = value;

           // Mark all checkboxes for the selected category
           if (value === 'all') {
               // Don't check any specific subcategory
           } else if (value === 'gender') {
               newGenderChecked = { fem: true, masc: true, neut: true };
               setAdjectivesGenderChecked(newGenderChecked);
           } else if (value === 'animacy') {
               newAnimacyChecked = { anim: true, inan: true };
               setAdjectivesAnimacyChecked(newAnimacyChecked);
           } else if (value === 'number') {
               newNumberChecked = { sing: true, plur: true };
               setAdjectivesNumberChecked(newNumberChecked);
           } else if (value === 'case') {
               newCaseChecked = { nom: true, gen: true, acc: true, dat: true, ins: true, loc: true };
               setAdjectivesCaseChecked(newCaseChecked);
           } else if (value === 'degree') {
               newDegreeChecked = { pos: true, cmp: true, sup: true };
               setAdjectivesDegreeChecked(newDegreeChecked);
           } else if (value === 'form') {
               newFormChecked = { short: true };
               setAdjectivesFormChecked(newFormChecked);
           }
       } else if (type === 'checkbox') {
           // Handle checkbox changes for subcategories
           // Gender
           const genderMatch = id.match(/adjectives-gender-(fem|masc|neut)/);
           if (genderMatch) {
               const key = genderMatch[1];
               newGenderChecked = { ...adjectivesGenderChecked, [key]: checked };
               setAdjectivesGenderChecked(newGenderChecked);
           }
           // Animacy
           const animacyMatch = id.match(/adjectives-animacy-(anim|inan)/);
           if (animacyMatch) {
               const key = animacyMatch[1];
               newAnimacyChecked = { ...adjectivesAnimacyChecked, [key]: checked };
               setAdjectivesAnimacyChecked(newAnimacyChecked);
           }
           // Number
           const numberMatch = id.match(/adjectives-number-(sing|plur)/);
           if (numberMatch) {
               const key = numberMatch[1];
               newNumberChecked = { ...adjectivesNumberChecked, [key]: checked };
               setAdjectivesNumberChecked(newNumberChecked);
           }
           // Case
           const caseMatch = id.match(/adjectives-case-(nom|gen|acc|dat|ins|loc)/);
           if (caseMatch) {
               const key = caseMatch[1];
               newCaseChecked = { ...adjectivesCaseChecked, [key]: checked };
               setAdjectivesCaseChecked(newCaseChecked);
           }
           // Degree
           const degreeMatch = id.match(/adjectives-degree-(pos|cmp|sup)/);
           if (degreeMatch) {
               const key = degreeMatch[1];
               newDegreeChecked = { ...adjectivesDegreeChecked, [key]: checked };
               setAdjectivesDegreeChecked(newDegreeChecked);
           }
           // Form
           if (id === 'adjectives-form-short') {
               newFormChecked = { short: checked };
               setAdjectivesFormChecked(newFormChecked);
           }
       }

       formatText(props.analyzedText.main,
        pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, pragmaticsSize, pragmaticsBold, pragmaticsItalic, pragmaticsUnderline,
        phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
        nounsFilterActive,
        nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
        nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
        properNounsFilterActive,
        properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
        properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
        numeralsFilterActive,
        numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
        numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
        adjectivesFilterActive, newFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
        newGenderChecked, newAnimacyChecked, newNumberChecked, newCaseChecked, newDegreeChecked, newFormChecked,
        adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
        adverbsDegreeChecked,
        verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
        verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
        prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
        subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
        determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
        pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
        pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
        conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleAdverbsFilterChange = (event) => {
        setPragmaticsFilterActive(false);
        setPragmaticsFilterOption('all');
        setPragmaticColor('');
        setPragmaticSize('');
        setPragmaticBold(false);
        setPragmaticItalic(false);
        setPragmaticUnderline(false);
        setPhrasalVerbsFilterActive(false);
        //setPhrasalVerbsFilterOption('all');
        setPhrasalVerbsColor('');
        setPhrasalVerbsSize('');
        setPhrasalVerbsBold(false);
        setPhrasalVerbsItalic(false);
        setPhrasalVerbsUnderline(false);
        setAdverbsColor('');
        setAdverbsSize('');
        setAdverbsBold(false);
        setAdverbsItalic(false);
        setAdverbsUnderline(false);
        setAdverbsFilterActive(event.target.checked);
        formatText(props.analyzedText.main,
            false, '', '', '', false, false, false,
            false, '', '', false, false, false,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            'all', '', '', false, false, false,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline,
            particlesFilterOption, particlesColor, particlesSize, particlesBold, particlesItalic, particlesUnderline);
    }

    const handleAdverbsFilterOptionChange = (event) => {
       const type = event.target.type;
       const value = event.target.value;
       const id = event.target.id;
       let newFilterOption = adverbsFilterOption;
       let newDegreeChecked = { ...adverbsDegreeChecked };

       // Only change filter option if it's a radio button, not a checkbox
       if (type === 'radio') {
           setAdverbsFilterOption(value);
           registerNlpStart(props.task_id, 'Word Categories', 'Adverbs', value);
           newFilterOption = value;

           // Mark all checkboxes for the selected category
           if (value === 'degree') {
               newDegreeChecked = { cmp: true, sup: true };
               setAdverbsDegreeChecked(newDegreeChecked);
           }
       } else if (type === 'checkbox') {
           // Handle checkbox changes for degree options
           if (id === 'adverbs-degree-cmp') {
               newDegreeChecked.cmp = event.target.checked;
               setAdverbsDegreeChecked(newDegreeChecked);
           } else if (id === 'adverbs-degree-sup') {
               newDegreeChecked.sup = event.target.checked;
               setAdverbsDegreeChecked(newDegreeChecked);
           }
       }

       formatText(props.analyzedText.main,
        pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, pragmaticsSize, pragmaticsBold, pragmaticsItalic, pragmaticsUnderline,
        phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
        nounsFilterActive,
        nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
        nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
        properNounsFilterActive,
        properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
        properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
        numeralsFilterActive,
        numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
        numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
        adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
        adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
        newFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
        newDegreeChecked,
        verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
        verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
        prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
        subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
        determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
        pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
        pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
        conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleVerbsFilterChange = (event) => {
        setPragmaticsFilterActive(false);
        setPragmaticsFilterOption('all');
        setPragmaticColor('');
        setPragmaticSize('');
        setPragmaticBold(false);
        setPragmaticItalic(false);
        setPragmaticUnderline(false);
        setPhrasalVerbsFilterActive(false);
        //setPhrasalVerbsFilterOption('all');
        setPhrasalVerbsColor('');
        setPhrasalVerbsSize('');
        setPhrasalVerbsBold(false);
        setPhrasalVerbsItalic(false);
        setPhrasalVerbsUnderline(false);
        setVerbsFilterActive(event.target.checked);
        setVerbsFilterOption('all');
        setVerbTensOptions(emptyVerbTensOptions);
        setVerbsColor('');
        setVerbsSize('');
        setVerbsBold(false);
        setVerbsItalic(false);
        setVerbsUnderline(false);
        formatText(props.analyzedText.main,
            false, '', '', '', false, false, false,
            false, '', '', false, false, false,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            'all', emptyVerbTensOptions, '', '', false, false, false,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline,
            particlesFilterOption, particlesColor, particlesSize, particlesBold, particlesItalic, particlesUnderline);
    }
    
    const handleVerbsFilterOptionChange = (event) => {
        const type = event.target.type;
        const value = event.target.value;
        const id = event.target.id;
        const checked = event.target.checked;
        let newFilterOption = verbsFilterOption;
        let newVerbTensOptions = verbTenseOptions;
        let newAspectChecked = verbsAspectChecked;
        let newTenseChecked = verbsTenseChecked;
        let newMoodChecked = verbsMoodChecked;
        let newGenderChecked = verbsGenderChecked;
        let newNumberChecked = verbsNumberChecked;
        let newPersonChecked = verbsPersonChecked;
        let newVerbFormChecked = verbsVerbFormChecked;
        let newVoiceChecked = verbsVoiceChecked;

        // Only change filter option if it's a radio button, not a checkbox
        if (type === 'radio') {
            setVerbsFilterOption(value);
            setVerbTensOptions(emptyVerbTensOptions);
            registerNlpStart(props.task_id, 'Word Categories', 'Verbs', value);
            newFilterOption = value;
            newVerbTensOptions = emptyVerbTensOptions;

            // Mark all checkboxes for the selected category
            if (value === 'all') {
                // Don't check any specific subcategory
            } else if (value === 'aspect') {
                newAspectChecked = { imp: true, perf: true };
                setVerbsAspectChecked(newAspectChecked);
            } else if (value === 'mood') {
                newMoodChecked = { ind: true, cnd: true, imp: true };
                setVerbsMoodChecked(newMoodChecked);
            } else if (value === 'tense') {
                newTenseChecked = { past: true, pres: true, fut: true };
                setVerbsTenseChecked(newTenseChecked);
            } else if (value === 'gender') {
                newGenderChecked = { fem: true, masc: true, neut: true };
                setVerbsGenderChecked(newGenderChecked);
            } else if (value === 'number') {
                newNumberChecked = { sing: true, plur: true };
                setVerbsNumberChecked(newNumberChecked);
            } else if (value === 'person') {
                newPersonChecked = { first: true, second: true, third: true };
                setVerbsPersonChecked(newPersonChecked);
            } else if (value === 'verbform') {
                newVerbFormChecked = { fin: true, inf: true, conv: true, part: true };
                setVerbsVerbFormChecked(newVerbFormChecked);
            } else if (value === 'voice') {
                newVoiceChecked = { act: true, mid: true, pass: true };
                setVerbsVoiceChecked(newVoiceChecked);
            }
        } else if (type === 'checkbox') {
            // Aspect
            const aspectMatch = id.match(/verbs-aspect-(imp|perf)/);
            if (aspectMatch) {
                const key = aspectMatch[1];
                newAspectChecked = { ...verbsAspectChecked, [key]: checked };
                setVerbsAspectChecked(newAspectChecked);
            }
            // Mood
            const moodMatch = id.match(/verbs-mood-(ind|cnd|imp)/);
            if (moodMatch) {
                const key = moodMatch[1];
                newMoodChecked = { ...verbsMoodChecked, [key]: checked };
                setVerbsMoodChecked(newMoodChecked);
            }
            // Tense
            const tenseMatch = id.match(/verbs-tense-(past|pres|fut)/);
            if (tenseMatch) {
                const key = tenseMatch[1];
                newTenseChecked = { ...verbsTenseChecked, [key]: checked };
                setVerbsTenseChecked(newTenseChecked);
            }
            // Gender
            const genderMatch = id.match(/verbs-gender-(fem|masc|neut)/);
            if (genderMatch) {
                const key = genderMatch[1];
                newGenderChecked = { ...verbsGenderChecked, [key]: checked };
                setVerbsGenderChecked(newGenderChecked);
            }
            // Number
            const numberMatch = id.match(/verbs-number-(sing|plur)/);
            if (numberMatch) {
                const key = numberMatch[1];
                newNumberChecked = { ...verbsNumberChecked, [key]: checked };
                setVerbsNumberChecked(newNumberChecked);
            }
            // Person
            const personMatch = id.match(/verbs-person-(first|second|third)/);
            if (personMatch) {
                const key = personMatch[1];
                newPersonChecked = { ...verbsPersonChecked, [key]: checked };
                setVerbsPersonChecked(newPersonChecked);
            }
            // VerbForm
            const verbFormMatch = id.match(/verbs-verbform-(fin|inf|conv|part)/);
            if (verbFormMatch) {
                const key = verbFormMatch[1];
                newVerbFormChecked = { ...verbsVerbFormChecked, [key]: checked };
                setVerbsVerbFormChecked(newVerbFormChecked);
            }
            // Voice
            const voiceMatch = id.match(/verbs-voice-(act|mid|pass)/);
            if (voiceMatch) {
                const key = voiceMatch[1];
                newVoiceChecked = { ...verbsVoiceChecked, [key]: checked };
                setVerbsVoiceChecked(newVoiceChecked);
            }
        }

        formatText(props.analyzedText.main,
            pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, pragmaticsSize, pragmaticsBold, pragmaticsItalic, pragmaticsUnderline,
            phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            newFilterOption, newVerbTensOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            newAspectChecked, newTenseChecked, newMoodChecked, newGenderChecked, newNumberChecked, newPersonChecked, newVerbFormChecked, newVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline,
            particlesFilterOption, particlesColor, particlesSize, particlesBold, particlesItalic, particlesUnderline);
     }

     const handleVerbsTensOptionChange = (event: any) => {
         const newVerbTenseOptions = Object.assign({}, verbTenseOptions);
         switch (event.target.id) {
             case 'verbs-tense-Present_Simple':
                 newVerbTenseOptions.Present_Simple = event.target.checked;
                 break;
             case 'verbs-tense-Present_Continuous':
                 newVerbTenseOptions.Present_Continuous = event.target.checked;
                 break;
             case 'verbs-tense-Present_Perfect':
                 newVerbTenseOptions.Present_Perfect = event.target.checked;
                 break;
             case 'verbs-tense-Present_Perfect_Continuous':
                 newVerbTenseOptions.Present_Perfect_Continuous = event.target.checked;
                 break;
             case 'verbs-tense-Past_Simple':
                 newVerbTenseOptions.Past_Simple = event.target.checked;
                 break;
             case 'verbs-tense-Past_Continuous':
                 newVerbTenseOptions.Past_Continuous = event.target.checked;
                 break;
             case 'verbs-tense-Past_Perfect':
                 newVerbTenseOptions.Past_Perfect = event.target.checked;
                 break;
             case 'verbs-tense-Past_Perfect_Continuous':
                 newVerbTenseOptions.Past_Perfect_Continuous = event.target.checked;
                 break;
             case 'verbs-tense-Future_Be_Going_To':
                 newVerbTenseOptions.Future_Be_Going_To = event.target.checked;
                 break;
             case 'verbs-tense-Future_Simple':
                 newVerbTenseOptions.Future_Simple = event.target.checked;
                 break;
             case 'verbs-tense-Future_Perfect':
                 newVerbTenseOptions.Future_Perfect = event.target.checked;
                 break;
             case 'verbs-tense-Future_Perfect_Continuous':
                 newVerbTenseOptions.Future_Perfect_Continuous = event.target.checked;
                 break;
             case 'verbs-tense-Present_Simple_Passive':
                 newVerbTenseOptions.Present_Simple_Passive = event.target.checked;
                 break;
             case 'verbs-tense-Present_Continuous_Passive':
                 newVerbTenseOptions.Present_Continuous_Passive = event.target.checked;
                 break;
             case 'verbs-tense-Present_Perfect_Passive':
                 newVerbTenseOptions.Present_Perfect_Passive = event.target.checked;
                 break;
             case 'verbs-tense-Present_Perfect_Continuous_Passive':
                 newVerbTenseOptions.Present_Perfect_Continuous_Passive = event.target.checked;
                 break;
             case 'verbs-tense-Past_Simple_Passive':
                 newVerbTenseOptions.Past_Simple_Passive = event.target.checked;
                 break;
             case 'verbs-tense-Past_Continuous_Passive':
                 newVerbTenseOptions.Past_Continuous_Passive = event.target.checked;
                 break;
             case 'verbs-tense-Past_Perfect_Passive':
                 newVerbTenseOptions.Past_Perfect_Passive = event.target.checked;
                 break;
             case 'verbs-tense-Past_Perfect_Continuous_Passive':
                 newVerbTenseOptions.Past_Perfect_Continuous_Passive = event.target.checked;
                 break;
             case 'verbs-tense-Future_Simple_Passive':
                 newVerbTenseOptions.Future_Simple_Passive = event.target.checked;
                 break;
             case 'verbs-tense-Future_Perfect_Passive':
                 newVerbTenseOptions.Future_Perfect_Passive = event.target.checked;
                 break;
         }
         setVerbTensOptions(newVerbTenseOptions);
         formatText(props.analyzedText.main,
            pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, pragmaticsSize, pragmaticsBold, pragmaticsItalic, pragmaticsUnderline,
            phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, newVerbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handlePrepositionsFilterChange = (event) => {
        setPragmaticsFilterActive(false);
        setPragmaticsFilterOption('all');
        setPragmaticColor('');
        setPragmaticSize('');
        setPragmaticBold(false);
        setPragmaticItalic(false);
        setPragmaticUnderline(false);
        setPhrasalVerbsFilterActive(false);
        //setPhrasalVerbsFilterOption('all');
        setPhrasalVerbsColor('');
        setPhrasalVerbsSize('');
        setPhrasalVerbsBold(false);
        setPhrasalVerbsItalic(false);
        setPhrasalVerbsUnderline(false);
        setPrepositionsColor('');
        setPrepositionsSize('');
        setPrepositionsBold(false);
        setPrepositionsItalic(false);
        setPrepositionsUnderline(false);
        setPrepositionsFilterActive(event.target.checked);
        formatText(props.analyzedText.main,
            false, '', '', '', false, false, false,
            false, '', '', false, false, false,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            'all', '', '', false, false, false,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }
    
    const handlePrepositionsFilterOptionChange = (event) => {
        setPrepositionsFilterOption(event.target.value);
        registerNlpStart(props.task_id, 'Word Categories', 'Preposition', event.target.value);
        formatText(props.analyzedText.main,
            pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, pragmaticsSize, pragmaticsBold, pragmaticsItalic, pragmaticsUnderline,
            phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            event.target.value, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleSubConjunctionsFilterChange = (event) => {
        setPragmaticsFilterActive(false);
        setPragmaticsFilterOption('all');
        setPragmaticColor('');
        setPragmaticSize('');
        setPragmaticBold(false);
        setPragmaticItalic(false);
        setPragmaticUnderline(false);
        setPhrasalVerbsFilterActive(false);
        //setPhrasalVerbsFilterOption('all');
        setPhrasalVerbsColor('');
        setPhrasalVerbsSize('');
        setPhrasalVerbsBold(false);
        setPhrasalVerbsItalic(false);
        setPhrasalVerbsUnderline(false);
        setSubConjunctionsColor('');
        setSubConjunctionsSize('');
        setSubConjunctionsBold(false);
        setSubConjunctionsItalic(false);
        setSubConjunctionsUnderline(false);
        setSubConjunctionsFilterActive(event.target.checked);
        formatText(props.analyzedText.main,
            false, '', '', '', false, false, false,
            false, '', '', false, false, false,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            'all', '', '', false, false, false,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }
    
    const handleSubConjunctionsFilterOptionChange = (event) => {
        setPrepositionsFilterOption(event.target.value);
        registerNlpStart(props.task_id, 'Word Categories', 'SubConjunction', event.target.value);
        formatText(props.analyzedText.main,
            pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, pragmaticsSize, pragmaticsBold, pragmaticsItalic, pragmaticsUnderline,
            phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            event.target.value, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleDeterminersFilterChange = (event) => {
        setPragmaticsFilterActive(false);
        setPragmaticsFilterOption('all');
        setPragmaticColor('');
        setPragmaticSize('');
        setPragmaticBold(false);
        setPragmaticItalic(false);
        setPragmaticUnderline(false);
        setPhrasalVerbsFilterActive(false);
        //setPhrasalVerbsFilterOption('all');
        setPhrasalVerbsColor('');
        setPhrasalVerbsSize('');
        setPhrasalVerbsBold(false);
        setPhrasalVerbsItalic(false);
        setPhrasalVerbsUnderline(false);
        setDeterminersColor('');
        setDeterminersSize('');
        setDeterminersBold(false);
        setDeterminersItalic(false);
        setDeterminersUnderline(false);
        setDeterminersFilterActive(false);
        setSubConjunctionsColor('');
        setSubConjunctionsSize('');
        setSubConjunctionsBold(false);
        setSubConjunctionsItalic(false);
        setSubConjunctionsUnderline(false);
        setSubConjunctionsFilterActive(false);
        formatText(props.analyzedText.main,
            false, '', '', '', false, false, false,
            false, '', '', false, false, false,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            'all', '', '', false, false, false,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }
    
    const handleDeterminersFilterOptionChange = (event) => {
        setDeterminersFilterOption(event.target.value);
        registerNlpStart(props.task_id, 'Word Categories', 'Determiners', event.target.value);
        formatText(props.analyzedText.main,
         pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, pragmaticsSize, pragmaticsBold, pragmaticsItalic, pragmaticsUnderline,
         phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
         nounsFilterActive,
         nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
         nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
         properNounsFilterActive,
         properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
         properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
         numeralsFilterActive,
         numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
         numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
         adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
         adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
         adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
         adverbsDegreeChecked,
         verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
         verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
         prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
         subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
         event.target.value, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
         pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
         pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
         conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handlePronounsFilterChange = (event) => {
        setPragmaticsFilterActive(false);
        setPragmaticsFilterOption('all');
        setPragmaticColor('');
        setPragmaticSize('');
        setPragmaticBold(false);
        setPragmaticItalic(false);
        setPragmaticUnderline(false);
        setPhrasalVerbsFilterActive(false);
        //setPhrasalVerbsFilterOption('all');
        setPhrasalVerbsColor('');
        setPhrasalVerbsSize('');
        setPhrasalVerbsBold(false);
        setPhrasalVerbsItalic(false);
        setPhrasalVerbsUnderline(false);
        setPronounsColor('');
        setPronounsSize('');
        setPronounsBold(false);
        setPronounsItalic(false);
        setPronounsUnderline(false);
        setPronounsFilterActive(event.target.checked);
        formatText(props.analyzedText.main,
            false, '', '', '', false, false, false,
            false, '', '', false, false, false,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            'all', '', '', false, false, false,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }
    
    const handlePronounsFilterOptionChange = (event) => {
        const type = event.target.type;
        const value = event.target.value;
        const id = event.target.id;
        let newFilterOption = pronounsFilterOption;
        let newGenderChecked = { ...pronounsGenderChecked };
        let newAnimacyChecked = { ...pronounsAnimacyChecked };
        let newNumberChecked = { ...pronounsNumberChecked };
        let newCaseChecked = { ...pronounsCaseChecked };
        let newPersonChecked = { ...pronounsPersonChecked };
        let newPronTypeChecked = { ...pronounsPronTypeChecked };

        // Only change filter option if it's a radio button, not a checkbox
        if (type === 'radio') {
            setPronounsFilterOption(value);
            registerNlpStart(props.task_id, 'Word Categories', 'Pronouns', value);
            newFilterOption = value;

            // Mark all checkboxes for the selected category
            if (value === 'gender') {
                newGenderChecked = { fem: true, masc: true, neut: true };
                setPronounsGenderChecked(newGenderChecked);
            } else if (value === 'animacy') {
                newAnimacyChecked = { anim: true, inan: true };
                setPronounsAnimacyChecked(newAnimacyChecked);
            } else if (value === 'number') {
                newNumberChecked = { sing: true, plur: true };
                setPronounsNumberChecked(newNumberChecked);
            } else if (value === 'case') {
                newCaseChecked = { nom: true, gen: true, acc: true, dat: true, ins: true, loc: true };
                setPronounsCaseChecked(newCaseChecked);
            } else if (value === 'person') {
                newPersonChecked = { first: true, second: true, third: true };
                setPronounsPersonChecked(newPersonChecked);
            } else if (value === 'prontype') {
                newPronTypeChecked = { prs: true, ind: true, dem: true };
                setPronounsPronTypeChecked(newPronTypeChecked);
            }
        } else if (type === 'checkbox') {
            // Handle checkbox changes for gender options
            if (id === 'pronouns-gender-fem') {
                newGenderChecked.fem = event.target.checked;
                setPronounsGenderChecked(newGenderChecked);
            } else if (id === 'pronouns-gender-masc') {
                newGenderChecked.masc = event.target.checked;
                setPronounsGenderChecked(newGenderChecked);
            } else if (id === 'pronouns-gender-neut') {
                newGenderChecked.neut = event.target.checked;
                setPronounsGenderChecked(newGenderChecked);
            }
            // Handle checkbox changes for animacy options
            else if (id === 'pronouns-animacy-anim') {
                newAnimacyChecked.anim = event.target.checked;
                setPronounsAnimacyChecked(newAnimacyChecked);
            } else if (id === 'pronouns-animacy-inan') {
                newAnimacyChecked.inan = event.target.checked;
                setPronounsAnimacyChecked(newAnimacyChecked);
            }
            // Handle checkbox changes for number options
            else if (id === 'pronouns-number-sing') {
                newNumberChecked.sing = event.target.checked;
                setPronounsNumberChecked(newNumberChecked);
            } else if (id === 'pronouns-number-plur') {
                newNumberChecked.plur = event.target.checked;
                setPronounsNumberChecked(newNumberChecked);
            }
            // Handle checkbox changes for case options
            else if (id === 'pronouns-case-nom') {
                newCaseChecked.nom = event.target.checked;
                setPronounsCaseChecked(newCaseChecked);
            } else if (id === 'pronouns-case-gen') {
                newCaseChecked.gen = event.target.checked;
                setPronounsCaseChecked(newCaseChecked);
            } else if (id === 'pronouns-case-acc') {
                newCaseChecked.acc = event.target.checked;
                setPronounsCaseChecked(newCaseChecked);
            } else if (id === 'pronouns-case-dat') {
                newCaseChecked.dat = event.target.checked;
                setPronounsCaseChecked(newCaseChecked);
            } else if (id === 'pronouns-case-ins') {
                newCaseChecked.ins = event.target.checked;
                setPronounsCaseChecked(newCaseChecked);
            } else if (id === 'pronouns-case-loc') {
                newCaseChecked.loc = event.target.checked;
                setPronounsCaseChecked(newCaseChecked);
            }
            // Handle checkbox changes for person options
            else if (id === 'pronouns-person-1') {
                newPersonChecked.first = event.target.checked;
                setPronounsPersonChecked(newPersonChecked);
            } else if (id === 'pronouns-person-2') {
                newPersonChecked.second = event.target.checked;
                setPronounsPersonChecked(newPersonChecked);
            } else if (id === 'pronouns-person-3') {
                newPersonChecked.third = event.target.checked;
                setPronounsPersonChecked(newPersonChecked);
            }
            // Handle checkbox changes for prontype options
            else if (id === 'pronouns-prontype-prs') {
                newPronTypeChecked.prs = event.target.checked;
                setPronounsPronTypeChecked(newPronTypeChecked);
            } else if (id === 'pronouns-prontype-ind') {
                newPronTypeChecked.ind = event.target.checked;
                setPronounsPronTypeChecked(newPronTypeChecked);
            } else if (id === 'pronouns-prontype-dem') {
                newPronTypeChecked.dem = event.target.checked;
                setPronounsPronTypeChecked(newPronTypeChecked);
            }
        }

        formatText(props.analyzedText.main,
            pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, pragmaticsSize, pragmaticsBold, pragmaticsItalic, pragmaticsUnderline,
            phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            newFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            newGenderChecked, newAnimacyChecked, newNumberChecked, newCaseChecked, newPersonChecked, newPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline,
            particlesFilterOption, particlesColor, particlesSize, particlesBold, particlesItalic, particlesUnderline);
    }

    const handleConjunctionsFilterChange = (event) => {
        setPragmaticsFilterActive(false);
        setPragmaticsFilterOption('all');
        setPragmaticColor('');
        setPragmaticSize('');
        setPragmaticBold(false);
        setPragmaticItalic(false);
        setPragmaticUnderline(false);
        setPhrasalVerbsFilterActive(false);
        //setPhrasalVerbsFilterOption('all');
        setPhrasalVerbsColor('');
        setPhrasalVerbsSize('');
        setPhrasalVerbsBold(false);
        setPhrasalVerbsItalic(false);
        setPhrasalVerbsUnderline(false);
        setConjunctionsColor('');
        setConjunctionsSize('');
        setConjunctionsBold(false);
        setConjunctionsItalic(false);
        setConjunctionsUnderline(false);
        setConjunctionsFilterActive(event.target.checked);
        formatText(props.analyzedText.main,
            false, '', '', '', false, false, false,
            false, '', '', false, false, false,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            event.target.checked ? 'all' : '', '', '', false, false, false,
            particlesFilterOption, particlesColor, particlesSize, particlesBold, particlesItalic, particlesUnderline);
    }

    const handleConjunctionsFilterOptionChange = (event) => {
        setConjunctionsFilterOption(event.target.value);
        registerNlpStart(props.task_id, 'Word Categories', 'Conjunctions', event.target.value);
        formatText(props.analyzedText.main,
            pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, pragmaticsSize, pragmaticsBold, pragmaticsItalic, pragmaticsUnderline,
            phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            event.target.value, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline,
            particlesFilterOption, particlesColor, particlesSize, particlesBold, particlesItalic, particlesUnderline);
    }

    const handleParticlesFilterChange = (event) => {
        setPragmaticsFilterActive(false);
        setPragmaticsFilterOption('all');
        setPragmaticColor('');
        setPragmaticSize('');
        setPragmaticBold(false);
        setPragmaticItalic(false);
        setPragmaticUnderline(false);
        setPhrasalVerbsFilterActive(false);
        setPhrasalVerbsColor('');
        setPhrasalVerbsSize('');
        setPhrasalVerbsBold(false);
        setPhrasalVerbsItalic(false);
        setPhrasalVerbsUnderline(false);
        setParticlesColor('');
        setParticlesSize('');
        setParticlesBold(false);
        setParticlesItalic(false);
        setParticlesUnderline(false);
        setParticlesFilterActive(event.target.checked);
        formatText(props.analyzedText.main,
            false, '', '', '', false, false, false,
            false, '', '', false, false, false,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline,
            'all', '', '', false, false, false);
    }

    const handleParticlesFilterOptionChange = (event) => {
        setParticlesFilterOption(event.target.value);
        registerNlpStart(props.task_id, 'Word Categories', 'Particles', event.target.value);
        formatText(props.analyzedText.main,
            pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, pragmaticsSize, pragmaticsBold, pragmaticsItalic, pragmaticsUnderline,
            phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline,
            event.target.value, particlesColor, particlesSize, particlesBold, particlesItalic, particlesUnderline);
    }

    const setColor = (event: any) => {
        registerNlpStart(props.task_id, 'Color', event.target.dataset.element, event.target.dataset.color);
        let newPragmaticColor = pragmaticsColor;
        let newPhrasalVerbsColor = phrasalVerbsColor;
        let newNounsColor = nounsColor;
        let newAdjectivesColor = adjectivesColor;
        let newAdverbsColor = adverbsColor;
        let newVerbsColor = verbsColor;
        let newPrepositionsColor = prepositionsColor;
        let newSubConjunctionsColor = subConjunctionsColor;
        let newDeterminersColor = determinersColor;
        let newPronounsColor = pronounsColor;
        let newConjunctionsColor = conjunctionsColor;
        let newProperNounsColor = properNounsColor;
        let newNumeralsColor = numeralsColor;
        let newParticlesColor = particlesColor;
        switch (event.target.dataset.element) {
            case 'pragmatic':
                setPragmaticColor(event.target.dataset.color);
                newPragmaticColor = event.target.dataset.color;
                break;
            case 'phrasalVerbs':
                setPhrasalVerbsColor(event.target.dataset.color);
                newPhrasalVerbsColor = event.target.dataset.color;
                break;    
            case 'noun':
                setNounsColor(event.target.dataset.color);
                newNounsColor = event.target.dataset.color;
                break;
            case 'adjective':
                setAdjectivesColor(event.target.dataset.color);
                newAdjectivesColor = event.target.dataset.color;
                break;
            case 'adverb':
                setAdverbsColor(event.target.dataset.color);
                newAdverbsColor = event.target.dataset.color;
                break;
            case 'verb':
                setVerbsColor(event.target.dataset.color);
                newVerbsColor = event.target.dataset.color;
                break;
            case 'preposition':
                setPrepositionsColor(event.target.dataset.color);
                newPrepositionsColor = event.target.dataset.color;
                break;    
            case 'subConjunction':
                setSubConjunctionsColor(event.target.dataset.color);
                newSubConjunctionsColor = event.target.dataset.color;
                break;    
            case 'determiner':
                setDeterminersColor(event.target.dataset.color);
                newDeterminersColor = event.target.dataset.color;
                break;
            case 'pronoun':
                setPronounsColor(event.target.dataset.color);
                newPronounsColor = event.target.dataset.color;
                break;
            case 'conjunctions':
                setConjunctionsColor(event.target.dataset.color);
                newConjunctionsColor = event.target.dataset.color;
                break;
            case 'propernoun':
                setProperNounsColor(event.target.dataset.color);
                newProperNounsColor = event.target.dataset.color;
                break;
            case 'numeral':
                setNumeralsColor(event.target.dataset.color);
                newNumeralsColor = event.target.dataset.color;
                break;
            case 'particles':
                setParticlesColor(event.target.dataset.color);
                newParticlesColor = event.target.dataset.color;
                break;
        }
        formatText(props.analyzedText.main,
            pragmaticsFilterActive, pragmaticsFilterOption, newPragmaticColor, pragmaticsSize, pragmaticsBold, pragmaticsItalic, pragmaticsUnderline,
            phrasalVerbsFilterActive, newPhrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
            nounsFilterActive,
            nounsFilterOption, newNounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, newProperNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, newNumeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, newAdjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, newAdverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, newVerbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, newPrepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, newSubConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, newDeterminersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, newPronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, newConjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline,
            particlesFilterOption, newParticlesColor, particlesSize, particlesBold, particlesItalic, particlesUnderline);
    }

    const setSize = (event: any) => {
        registerNlpStart(props.task_id, 'Size', event.target.dataset.element, event.target.dataset.size);
        let newPragmaticSize = pragmaticsSize;
        let newPhrasalVerbsSize = phrasalVerbsSize;
        let newNounsSize = nounsSize;
        let newAdjectivesSize = adjectivesSize;
        let newAdverbsSize = adverbsSize;
        let newVerbsSize = verbsSize;
        let newPrepositionsSize = prepositionsSize;
        let newSubConjunctionsSize = subConjunctionsSize;
        let newDeterminersSize = determinersSize;
        let newPronounsSize = pronounsSize;
        let newConjunctionsSize = conjunctionsSize;
        let newProperNounsSize = properNounsSize;
        let newNumeralsSize = numeralsSize;
        let newParticlesSize = particlesSize;
        switch (event.target.dataset.element) {
            case 'pragmatic':
                setPragmaticSize(event.target.dataset.size);
                newPragmaticSize = event.target.dataset.size;
                break;
            case 'phrasalVerbs':
                setPhrasalVerbsSize(event.target.dataset.size);
                newPhrasalVerbsSize = event.target.dataset.size;
                break;    
            case 'noun':
                setNounsSize(event.target.dataset.size);
                newNounsSize = event.target.dataset.size;
                break;
            case 'adjective':
                setAdjectivesSize(event.target.dataset.size);
                newAdjectivesSize = event.target.dataset.size;
                break;
            case 'adverb':
                setAdverbsSize(event.target.dataset.size);
                newAdverbsSize = event.target.dataset.size;
                break;
            case 'verb':
                setVerbsSize(event.target.dataset.size);
                newVerbsSize = event.target.dataset.size;
                break;
            case 'preposition':
                setPrepositionsSize(event.target.dataset.size);
                newPrepositionsSize = event.target.dataset.size;
                break;   
            case 'subConjunction':
                setSubConjunctionsSize(event.target.dataset.size);
                newSubConjunctionsSize = event.target.dataset.size;
                break;    
            case 'determiner':
                setDeterminersSize(event.target.dataset.size);
                newDeterminersSize = event.target.dataset.size;
                break;
            case 'pronoun':
                setPronounsSize(event.target.dataset.size);
                newPronounsSize = event.target.dataset.size;
                break;
            case 'conjunctions':
                setConjunctionsSize(event.target.dataset.size);
                newConjunctionsSize = event.target.dataset.size;
                break;
            case 'propernoun':
                setProperNounsSize(event.target.dataset.size);
                newProperNounsSize = event.target.dataset.size;
                break;
            case 'numeral':
                setNumeralsSize(event.target.dataset.size);
                newNumeralsSize = event.target.dataset.size;
                break;
            case 'particles':
                setParticlesSize(event.target.dataset.size);
                newParticlesSize = event.target.dataset.size;
                break;
        }
        formatText(props.analyzedText.main,
            pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, newPragmaticSize, pragmaticsBold, pragmaticsItalic, pragmaticsUnderline,
            phrasalVerbsFilterActive, phrasalVerbsColor, newPhrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
            nounsFilterActive,
            nounsFilterOption, nounsColor, newNounsSize, nounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, newProperNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, newNumeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, newAdjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, newAdverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, newVerbsSize, verbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, newPrepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, newSubConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, newDeterminersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, newPronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, newConjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline,
            particlesFilterOption, particlesColor, newParticlesSize, particlesBold, particlesItalic, particlesUnderline);
    }

    const setBold = (event: any) => {
        let newPragmaticBold = pragmaticsBold;
        let newPhrasalVerbsBold = phrasalVerbsBold;
        let newNounsBold = nounsBold;
        let newAdjectivesBold = adjectivesBold;
        let newAdverbsBold = adverbsBold;
        let newVerbsBold = verbsBold;
        let newPrepositionsBold = prepositionsBold;
        let newSubConjunctionsBold = subConjunctionsBold;
        let newDeterminersBold = determinersBold;
        let newPronounsBold = pronounsBold;
        let newConjunctionsBold = conjunctionsBold;
        let newProperNounsBold = properNounsBold;
        let newNumeralsBold = numeralsBold;
        let newParticlesBold = particlesBold;
        switch (event.target.dataset.element) {
            case 'pragmatic':
                setPragmaticBold(!pragmaticsBold);
                newPragmaticBold = !pragmaticsBold;
                registerNlpStart(props.task_id, 'Bold', event.target.dataset.element, newPragmaticBold ? 'yes' : 'no');
                break;
            case 'phrasalVerbs':
                setPhrasalVerbsBold(!phrasalVerbsBold);
                newPhrasalVerbsBold = !phrasalVerbsBold;
                registerNlpStart(props.task_id, 'Bold', event.target.dataset.element, newPhrasalVerbsBold ? 'yes' : 'no');
                break;
            case 'noun':
                setNounsBold(!nounsBold);
                newNounsBold = !nounsBold;
                registerNlpStart(props.task_id, 'Bold', event.target.dataset.element, newNounsBold ? 'yes' : 'no');
                break;
            case 'adjective':
                setAdjectivesBold(!adjectivesBold);
                newAdjectivesBold = !adjectivesBold;
                registerNlpStart(props.task_id, 'Bold', event.target.dataset.element, newAdjectivesBold ? 'yes' : 'no');
                break;
            case 'adverb':
                setAdverbsBold(!adverbsBold);
                newAdverbsBold = !adverbsBold;
                registerNlpStart(props.task_id, 'Bold', event.target.dataset.element, newAdverbsBold ? 'yes' : 'no');
                break;
            case 'verb':
                setVerbsBold(!verbsBold);
                newVerbsBold = !verbsBold;
                registerNlpStart(props.task_id, 'Bold', event.target.dataset.element, newVerbsBold ? 'yes' : 'no');
                break;
            case 'preposition':
                setPrepositionsBold(!prepositionsBold);
                newPrepositionsBold = !prepositionsBold;
                registerNlpStart(props.task_id, 'Bold', event.target.dataset.element, newPragmaticBold ? 'yes' : 'no');
                break;
            case 'subConjunction':
                setSubConjunctionsBold(!subConjunctionsBold);
                newSubConjunctionsBold = !subConjunctionsBold;
                registerNlpStart(props.task_id, 'Bold', event.target.dataset.element, newSubConjunctionsBold ? 'yes' : 'no');
                break;
            case 'determiner':
                setDeterminersBold(!determinersBold);
                newDeterminersBold = !determinersBold;
                registerNlpStart(props.task_id, 'Bold', event.target.dataset.element, newDeterminersBold ? 'yes' : 'no');
                break;
            case 'pronoun':
                setPronounsBold(!determinersBold);
                newPronounsBold = !determinersBold;
                registerNlpStart(props.task_id, 'Bold', event.target.dataset.element, newPronounsBold ? 'yes' : 'no');
                break;
            case 'conjunctions':
                setConjunctionsBold(!conjunctionsBold);
                newConjunctionsBold = !conjunctionsBold;
                registerNlpStart(props.task_id, 'Bold', event.target.dataset.element, newConjunctionsBold ? 'yes' : 'no');
                break;
            case 'propernoun':
                setProperNounsBold(!properNounsBold);
                newProperNounsBold = !properNounsBold;
                registerNlpStart(props.task_id, 'Bold', event.target.dataset.element, newProperNounsBold ? 'yes' : 'no');
                break;
            case 'numeral':
                setNumeralsBold(!numeralsBold);
                newNumeralsBold = !numeralsBold;
                registerNlpStart(props.task_id, 'Bold', event.target.dataset.element, newNumeralsBold ? 'yes' : 'no');
                break;
            case 'particles':
                setParticlesBold(!particlesBold);
                newParticlesBold = !particlesBold;
                registerNlpStart(props.task_id, 'Bold', event.target.dataset.element, newParticlesBold ? 'yes' : 'no');
                break;
        }

        formatText(props.analyzedText.main,
            pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, pragmaticsSize, newPragmaticBold, pragmaticsItalic, pragmaticsUnderline,
            phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, newPhrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, newNounsBold, nounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, newProperNounsBold, properNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, newNumeralsBold, numeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, newAdjectivesBold, adjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, newAdverbsBold, adverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, newVerbsBold, verbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, newPrepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, newSubConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, newDeterminersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, newPronounsBold, pronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, newConjunctionsBold, conjunctionsItalic, conjunctionsUnderline,
            particlesFilterOption, particlesColor, particlesSize, newParticlesBold, particlesItalic, particlesUnderline);
    }

    const setItalic = (event: any) => {
        let newPragmaticsItalic = pragmaticsItalic;
        let newPhrasalVerbsItalic = phrasalVerbsItalic;
        let newNounsItalic = nounsItalic;
        let newAdjectivesItalic = adjectivesItalic;
        let newAdverbsItalic = adverbsItalic;
        let newVerbsItalic = verbsItalic;
        let newPrepositionsItalic = prepositionsItalic;
        let newSubConjunctionsItalic = subConjunctionsItalic;
        let newDeterminersItalic = determinersItalic;
        let newPronounsItalic = pronounsItalic;
        let newConjunctionsItalic = conjunctionsItalic;
        let newProperNounsItalic = properNounsItalic;
        let newNumeralsItalic = numeralsItalic;
        let newParticlesItalic = particlesItalic;
        switch (event.target.dataset.element) {
            case 'pragmatic':
                setPragmaticItalic(!pragmaticsItalic);
                newPragmaticsItalic = !pragmaticsItalic;
                registerNlpStart(props.task_id, 'Italic', event.target.dataset.element, newPragmaticsItalic ? 'yes' : 'no');
                break;
            case 'phrasalVerbs':
                setPhrasalVerbsItalic(!phrasalVerbsItalic);
                newPhrasalVerbsItalic = !phrasalVerbsItalic;
                registerNlpStart(props.task_id, 'Italic', event.target.dataset.element, newPhrasalVerbsItalic ? 'yes' : 'no');
                break;
            case 'noun':
                setNounsItalic(!nounsItalic);
                newNounsItalic = !nounsItalic;
                registerNlpStart(props.task_id, 'Italic', event.target.dataset.element, newNounsItalic ? 'yes' : 'no');
                break;
            case 'adjective':
                setAdjectivesItalic(!adjectivesItalic);
                newAdjectivesItalic = !adjectivesItalic;
                registerNlpStart(props.task_id, 'Italic', event.target.dataset.element, newAdjectivesItalic ? 'yes' : 'no');
                break;
            case 'adverb':
                setAdverbsItalic(!adverbsItalic);
                newAdverbsItalic = !adverbsItalic;
                registerNlpStart(props.task_id, 'Italic', event.target.dataset.element, newAdverbsItalic ? 'yes' : 'no');
                break;
            case 'verb':
                setVerbsItalic(!verbsItalic);
                newVerbsItalic = !verbsItalic;
                registerNlpStart(props.task_id, 'Italic', event.target.dataset.element, newVerbsItalic ? 'yes' : 'no');
                break;
            case 'preposition':
                setPrepositionsItalic(!prepositionsItalic);
                newPrepositionsItalic = !prepositionsItalic;
                registerNlpStart(props.task_id, 'Italic', event.target.dataset.element, newPrepositionsItalic ? 'yes' : 'no');
                break;
            case 'subConjunction':
                setSubConjunctionsItalic(!subConjunctionsItalic);
                newSubConjunctionsItalic = !subConjunctionsItalic;
                registerNlpStart(props.task_id, 'Italic', event.target.dataset.element, newSubConjunctionsItalic ? 'yes' : 'no');
                break;
            case 'determiner':
                setDeterminersItalic(!determinersItalic);
                newDeterminersItalic = !determinersItalic;
                registerNlpStart(props.task_id, 'Italic', event.target.dataset.element, newDeterminersItalic ? 'yes' : 'no');
                break;
            case 'pronoun':
                setPronounsItalic(!pronounsItalic);
                newPronounsItalic = !pronounsItalic;
                registerNlpStart(props.task_id, 'Italic', event.target.dataset.element, newPronounsItalic ? 'yes' : 'no');
                break;
            case 'conjunctions':
                setConjunctionsItalic(!conjunctionsItalic);
                newConjunctionsItalic = !conjunctionsItalic;
                registerNlpStart(props.task_id, 'Italic', event.target.dataset.element, newConjunctionsItalic ? 'yes' : 'no');
                break;
            case 'propernoun':
                setProperNounsItalic(!properNounsItalic);
                newProperNounsItalic = !properNounsItalic;
                registerNlpStart(props.task_id, 'Italic', event.target.dataset.element, newProperNounsItalic ? 'yes' : 'no');
                break;
            case 'numeral':
                setNumeralsItalic(!numeralsItalic);
                newNumeralsItalic = !numeralsItalic;
                registerNlpStart(props.task_id, 'Italic', event.target.dataset.element, newNumeralsItalic ? 'yes' : 'no');
                break;
            case 'particles':
                setParticlesItalic(!particlesItalic);
                newParticlesItalic = !particlesItalic;
                registerNlpStart(props.task_id, 'Italic', event.target.dataset.element, newParticlesItalic ? 'yes' : 'no');
                break;
        }
        formatText(props.analyzedText.main,
            pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, pragmaticsSize, pragmaticsBold, newPragmaticsItalic, pragmaticsUnderline,
            phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, newPhrasalVerbsItalic, phrasalVerbsUnderline,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, newNounsItalic, nounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, newProperNounsItalic, properNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, newNumeralsItalic, numeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, newAdjectivesItalic, adjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, newAdverbsItalic, adverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, newVerbsItalic, verbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, newPrepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, newSubConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, newDeterminersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, newPronounsItalic, pronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, newConjunctionsItalic, conjunctionsUnderline,
            particlesFilterOption, particlesColor, particlesSize, particlesBold, newParticlesItalic, particlesUnderline);
    }

    const setUnderline = (event: any) => {
        let newPragmaticsUnderline = pragmaticsUnderline;
        let newPhrasalVerbsUnderline = phrasalVerbsUnderline;
        let newNounsUnderline = nounsUnderline;
        let newAdjectivesUnderline = adjectivesUnderline;
        let newAdverbsUnderline = adverbsUnderline;
        let newVerbsUnderline = verbsUnderline;
        let newPrepositionsUnderline = prepositionsUnderline;
        let newSubConjunctionsUnderline = subConjunctionsUnderline;
        let newDeterminersUnderline = determinersUnderline;
        let newPronounsUnderline = pronounsUnderline;
        let newConjunctionsUnderline = conjunctionsUnderline;
        let newProperNounsUnderline = properNounsUnderline;
        let newNumeralsUnderline = numeralsUnderline;
        let newParticlesUnderline = particlesUnderline;
        switch (event.target.dataset.element) {
            case 'pragmatic':
                setPragmaticUnderline(!pragmaticsUnderline);
                newPragmaticsUnderline = !pragmaticsUnderline;
                registerNlpStart(props.task_id, 'Underline', event.target.dataset.element, newPragmaticsUnderline ? 'yes' : 'no');
                break;
            case 'phrasalVerbs':
                setPhrasalVerbsUnderline(!phrasalVerbsUnderline);
                newPhrasalVerbsUnderline = !phrasalVerbsUnderline;
                registerNlpStart(props.task_id, 'Underline', event.target.dataset.element, newPhrasalVerbsUnderline ? 'yes' : 'no');
                break;
            case 'noun':
                setNounsUnderline(!nounsUnderline);
                newNounsUnderline = !nounsUnderline;
                registerNlpStart(props.task_id, 'Underline', event.target.dataset.element, newNounsUnderline ? 'yes' : 'no');
                break;
            case 'adjective':
                setAdjectivesUnderline(!adjectivesUnderline);
                newAdjectivesUnderline = !adjectivesUnderline;
                registerNlpStart(props.task_id, 'Underline', event.target.dataset.element, newAdjectivesUnderline ? 'yes' : 'no');
                break;
            case 'adverb':
                setAdverbsUnderline(!adverbsUnderline);
                newAdverbsUnderline = !adverbsUnderline;
                registerNlpStart(props.task_id, 'Underline', event.target.dataset.element, newAdverbsUnderline ? 'yes' : 'no');
                break;
            case 'verb':
                setVerbsUnderline(!verbsUnderline);
                newVerbsUnderline = !verbsUnderline;
                registerNlpStart(props.task_id, 'Underline', event.target.dataset.element, newVerbsUnderline ? 'yes' : 'no');
                break;
            case 'preposition':
                setPrepositionsUnderline(!prepositionsUnderline);
                newPrepositionsUnderline = !prepositionsUnderline;
                registerNlpStart(props.task_id, 'Underline', event.target.dataset.element, newPrepositionsUnderline ? 'yes' : 'no');
                break;
            case 'subConjunction':
                setSubConjunctionsUnderline(!subConjunctionsUnderline);
                newSubConjunctionsUnderline = !subConjunctionsUnderline;
                registerNlpStart(props.task_id, 'Underline', event.target.dataset.element, newSubConjunctionsUnderline ? 'yes' : 'no');
                break;
            case 'determiner':
                setDeterminersUnderline(!determinersUnderline);
                newDeterminersUnderline = !determinersUnderline;
                registerNlpStart(props.task_id, 'Underline', event.target.dataset.element, newDeterminersUnderline ? 'yes' : 'no');
                break;
            case 'pronoun':
                setPronounsUnderline(!pronounsUnderline);
                newPronounsUnderline = !pronounsUnderline;
                registerNlpStart(props.task_id, 'Underline', event.target.dataset.element, newPronounsUnderline ? 'yes' : 'no');
                break;
            case 'conjunctions':
                setConjunctionsUnderline(!conjunctionsUnderline);
                newConjunctionsUnderline = !conjunctionsUnderline;
                registerNlpStart(props.task_id, 'Underline', event.target.dataset.element, newConjunctionsUnderline ? 'yes' : 'no');
                break;
            case 'propernoun':
                setProperNounsUnderline(!properNounsUnderline);
                newProperNounsUnderline = !properNounsUnderline;
                registerNlpStart(props.task_id, 'Underline', event.target.dataset.element, newProperNounsUnderline ? 'yes' : 'no');
                break;
            case 'numeral':
                setNumeralsUnderline(!numeralsUnderline);
                newNumeralsUnderline = !numeralsUnderline;
                registerNlpStart(props.task_id, 'Underline', event.target.dataset.element, newNumeralsUnderline ? 'yes' : 'no');
                break;
            case 'particles':
                setParticlesUnderline(!particlesUnderline);
                newParticlesUnderline = !particlesUnderline;
                registerNlpStart(props.task_id, 'Underline', event.target.dataset.element, newParticlesUnderline ? 'yes' : 'no');
                break;
        }
        formatText(props.analyzedText.main,
            pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, pragmaticsSize, pragmaticsBold, pragmaticsItalic, newPragmaticsUnderline,
            phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, newPhrasalVerbsUnderline,
            nounsFilterActive,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, newNounsUnderline,
            nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
            properNounsFilterActive,
            properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, newProperNounsUnderline,
            properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
            numeralsFilterActive,
            numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, newNumeralsUnderline,
            numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
            adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, newAdjectivesUnderline,
            adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, newAdverbsUnderline,
            adverbsDegreeChecked,
            verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, newVerbsUnderline,
            verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, newPrepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, newSubConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, newDeterminersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, newPronounsUnderline,
            pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, newConjunctionsUnderline,
            particlesFilterOption, particlesColor, particlesSize, particlesBold, particlesItalic, newParticlesUnderline);
    }

    const colorOptions = (element: string, activeitem: string) => {
        return  <div className="color-selector">
            <span className={ 'color-item blue-violet' + (activeitem == 'blue-violet' ? ' active' : '') } 
                data-element={ element } data-color="blue-violet" onClick={ setColor }></span>
            <span className={ 'color-item brown' + (activeitem == 'brown' ? ' active' : '') } 
                data-element={ element } data-color="brown" onClick={ setColor }></span>
            <span className={ 'color-item coral' + (activeitem == 'coral' ? ' active' : '') } 
                data-element={ element } data-color="coral" onClick={ setColor }></span>
            <span className={ 'color-item dark-blue' + (activeitem == 'dark-blue' ? ' active' : '') }
                data-element={ element } data-color="dark-blue" onClick={ setColor }></span>
            <span className={ 'color-item dark-cyan' + (activeitem == 'dark-cyan' ? ' active' : '') }
                data-element={ element } data-color="dark-cyan" onClick={ setColor }></span>
            <span className={ 'color-item crimson' + (activeitem == 'crimson' ? ' active' : '') }
                data-element={ element } data-color="crimson" onClick={ setColor }></span>
            <span className={ 'color-item dark-green' + (activeitem == 'dark-green' ? ' active' : '') }
                data-element={ element } data-color="dark-green" onClick={ setColor }></span>
            <span className={ 'color-item dark-salmon' + (activeitem == 'dark-salmon' ? ' active' : '') }
                data-element={ element } data-color="dark-salmon" onClick={ setColor }></span>
            <span className={ 'color-item dark-orange' + (activeitem == 'dark-orange' ? ' active' : '') }
                data-element={ element } data-color="dark-orange" onClick={ setColor }></span>
            <span className={ 'color-item cadet-blue' + (activeitem == 'cadet-blue' ? ' active' : '') }
                data-element={ element } data-color="cadet-blue" onClick={ setColor }></span>
            <span className={ 'color-item chocolate' + (activeitem == 'chocolate' ? ' active' : '') }
                data-element={ element } data-color="chocolate" onClick={ setColor }></span>
            <span className={ 'color-item dark-magenta' + (activeitem == 'dark-magenta' ? ' active' : '') }
                data-element={ element } data-color="dark-magenta" onClick={ setColor }></span>
        </div>;
    }

    const sizeOptions = (element: string, activeitem: string) => {
        return  <div className="size-selector">
                <span className={ 'size-item normal' + (activeitem == 'normal' ? ' active' : '') }
                    data-element={ element } data-size="normal" onClick={ setSize }>{ 'A' }</span>
                <span className={ 'size-item big' + (activeitem == 'big' ? ' active' : '') }
                    data-element={ element } data-size="big" onClick={ setSize }>{ 'A' }</span>
                <span className={ 'size-item huge' + (activeitem == 'huge' ? ' active' : '') }
                    data-element={ element } data-size="huge" onClick={ setSize }>{ 'A' }</span>
            </div>;
    }

    function decodeColor(colorcode: string) {
        switch (colorcode) {
            case 'blue-violet':
                return 'blueviolet';
                break;
            case 'brown':
                return 'brown';
                break;
            case 'coral':
                return 'coral';
                break;
            case 'dark-blue':
                return 'darkblue';
                break;
            case 'dark-cyan':
                return 'darkcyan';
                break;
            case 'crimson':
                return 'crimson';
                break;
            case 'dark-green':
                return 'darkgreen';
                break;
            case 'dark-salmon':
                return 'darksalmon';
                break;  
            case 'dark-orange':
                return 'darkorange';
                break;
            case 'cadet-blue':
                return 'cadetblue';
                break; 
            case 'chocolate':
                return 'chocolate';
                break;     
            case 'dark-magenta':
                return 'darkmagenta';
                break; 
            default:
                return '';
        }
    }

    function decodeSize(sizecode: string) {
        switch (sizecode) {
            case 'big':
                return '1.4em';
                break;
            case 'huge':
                return '1.8em';
                break;
            default:
                return '';
        }
    }

    const formatText = (json: any,
        tmpPragmaticsFilterActive: boolean, tmpPragmaticsFilterOption: string, tmpPragmaticsColor: string, tmpPragmaticsSize: string, tmpPragmaticsBold: boolean, tmpPragmaticsItalic: boolean, tmpPragmaticsUnderline: boolean,
        tmpPhrasalVerbsFilterActive: boolean, tmpPhrasalVerbsColor: string, tmpPhrasalVerbsSize: string, tmpPhrasalVerbsBold: boolean, tmpPhrasalVerbsItalic: boolean, tmpPhrasalVerbsUnderline: boolean,
        tmpNounsFilterActive: boolean, tmpNounsFilterOption: string, tmpNounsColor: string, tmpNounsSize: string, tmpNounsBold: boolean, tmpNounsItalic: boolean, tmpNounsUnderline: boolean,
        tmpNounsGenderChecked: any, tmpNounsAnimacyChecked: any, tmpNounsNumberChecked: any, tmpNounsCaseChecked: any,
        tmpProperNounsFilterActive: boolean, tmpProperNounsFilterOption: string, tmpProperNounsColor: string, tmpProperNounsSize: string, tmpProperNounsBold: boolean, tmpProperNounsItalic: boolean, tmpProperNounsUnderline: boolean,
        tmpProperNounsGenderChecked: any, tmpProperNounsAnimacyChecked: any, tmpProperNounsNumberChecked: any, tmpProperNounsCaseChecked: any,
        tmpNumeralsFilterActive: boolean, tmpNumeralsFilterOption: string, tmpNumeralsColor: string, tmpNumeralsSize: string, tmpNumeralsBold: boolean, tmpNumeralsItalic: boolean, tmpNumeralsUnderline: boolean,
        tmpNumeralsGenderChecked: any, tmpNumeralsNumberChecked: any, tmpNumeralsCaseChecked: any, tmpNumeralsNumTypeChecked: any,
        tmpAdjectivesFilterActive: boolean, tmpAdjectivesFilterOption: string, tmpAdjectivesColor: string, tmpAdjectivesSize: string, tmpAdjectivesBold: boolean, tmpAdjectivesItalic: boolean, tmpAdjectivesUnderline: boolean,
        tmpAdjectivesGenderChecked: any, tmpAdjectivesAnimacyChecked: any, tmpAdjectivesNumberChecked: any, tmpAdjectivesCaseChecked: any, tmpAdjectivesDegreeChecked: any, tmpAdjectivesFormChecked: any,
        tmpAdverbsFilterOption: string, tmpAdverbsColor: string, tmpAdverbsSize: string, tmpAdverbsBold: boolean, tmpAdverbsItalic: boolean, tmpAdverbsUnderline: boolean,
        tmpAdverbsDegreeChecked: any,
        tmpVerbsFilterOption: string, tmpVerbTenseOptions: any, tmpVerbsColor: string, tmpVerbsSize: string, tmpVerbsBold: boolean, tmpVerbsItalic: boolean, tmpVerbsUnderline: boolean,
        tmpVerbsAspectChecked: any, tmpVerbsTenseChecked: any, tmpVerbsMoodChecked: any, tmpVerbsGenderChecked: any, tmpVerbsNumberChecked: any, tmpVerbsPersonChecked: any, tmpVerbsVerbFormChecked: any, tmpVerbsVoiceChecked: any,
        tmpPrepositionsFilterOption: string, tmpPrepositionsColor: string, tmpPrepositionsSize: string, tmpPrepositionsBold: boolean, tmpPrepositionsItalic: boolean, tmpPrepositionsUnderline: boolean,
        tmpSubConjunctionsFilterOption: string, tmpSubConjunctionsColor: string, tmpSubConjunctionsSize: string, tmpSubConjunctionsBold: boolean, tmpSubConjunctionsItalic: boolean, tmpSubConjunctionsUnderline: boolean,
        tmpDeterminersFilterOption: string, tmpDeterminersColor: string, tmpDeterminersSize: string, tmpDeterminersBold: boolean, tmpDeterminersItalic: boolean, tmpDeterminersUnderline: boolean,
        tmpPronounsFilterOption: string, tmpPronounsColor: string, tmpPronounsSize: string, tmpPronounsBold: boolean, tmpPronounsItalic: boolean, tmpPronounsUnderline: boolean,
        tmpPronounsGenderChecked: any, tmpPronounsAnimacyChecked: any, tmpPronounsNumberChecked: any, tmpPronounsCaseChecked: any, tmpPronounsPersonChecked: any, tmpPronounsPronTypeChecked: any,
        tmpConjunctionsFilterOption: string, tmpConjunctionsColor: string, tmpConjunctionsSize: string, tmpConjunctionsBold: boolean, tmpConjunctionsItalic: boolean, tmpConjunctionsUnderline: boolean,
        tmpParticlesFilterOption: string, tmpParticlesColor: string, tmpParticlesSize: string, tmpParticlesBold: boolean, tmpParticlesItalic: boolean, tmpParticlesUnderline: boolean) => {
        let resultAllText = '';
        if (json.length > 0) {
            let applyFormatToPos = false;
            let paragraphNum = json[0].paragraph;
            let sentenceNum = json[0].sentence;

            resultAllText = '<p>';
            let prevEndChar = 0;
            for (let i = 0; i < json.length; i++) {
                if (parseInt(json[i].sentence) != parseInt(sentenceNum)) {
                    resultAllText += ' ';
                    sentenceNum = json[i].sentence;
                }
                if (parseInt(json[i].paragraph) != parseInt(paragraphNum)) {
                    resultAllText += '</p><p>';
                    paragraphNum = json[i].paragraph;
                }
                if (prevEndChar != 0 && (prevEndChar < parseInt(json[i].start_char))) {
                    resultAllText += ' ';
                }
                let style = '';
                let classProps = '';
                applyFormatToPos = false;
                if (tmpPragmaticsFilterActive) {
                    if (json[i].pragmatics != '-') {
                        switch (tmpPragmaticsFilterOption) {
                            case 'suggesting':
                                applyFormatToPos = (json[i].pragmatics == 'Suggestion_Direct' ||
                                    json[i].pragmatics == 'Suggestion_Conventionalised' ||
                                    json[i].pragmatics == 'Suggestion_Indirect');
                                break;
                            case 'thanking':
                                applyFormatToPos = (json[i].pragmatics == 'Thanking_Informal' ||
                                    json[i].pragmatics == 'Thanking_Conventionalised' ||
                                    json[i].pragmatics == 'Thanking_Formal');
                                break;
                            case 'requesting':
                                applyFormatToPos = (json[i].pragmatics == 'Request_Direct' ||
                                    json[i].pragmatics == 'Request_Conventionalised' ||
                                    json[i].pragmatics == 'Request_Indirect');
                                break;
                            case 'agreeing-disagreeing':
                                applyFormatToPos = (json[i].pragmatics == 'Agreeing/Disagreeing_Informal' ||
                                    json[i].pragmatics == 'Agreeing/Disagreeing_Formal');
                                break;
                            case 'showing-interest':
                                applyFormatToPos = (json[i].pragmatics == 'Showing_Interest_Informal' ||
                                    json[i].pragmatics == 'Showing_Interest_Formal');
                                break;
                            case 'apologising':
                                applyFormatToPos = (json[i].pragmatics == 'Apologising_Conventionalised' ||
                                    json[i].pragmatics == 'Apologising_Informal' ||
                                    json[i].pragmatics == 'Apologising_Formal');
                                break;
                            case 'giving-an-opinion':
                                applyFormatToPos = (json[i].pragmatics == 'Giving_Opinion_Conventionalised' ||
                                    json[i].pragmatics == 'Giving_Opinion_Formal');
                                break;
                            case 'greeting':
                                applyFormatToPos = (json[i].pragmatics == 'Greeting_Informal' ||
                                    json[i].pragmatics == 'Greeting_Conventionalised' ||
                                    json[i].pragmatics == 'Greeting_Formal');
                                break;
                            default:
                                applyFormatToPos = true;
                                break;
                        }
                        if (applyFormatToPos) {
                            if (tmpPragmaticsColor) {
                                style += 'color:' + decodeColor(tmpPragmaticsColor) + ';';
                            }
                            if (tmpPragmaticsSize) {
                                style += 'font-size:' + decodeSize(tmpPragmaticsSize) + ';';
                                classProps = 'text-' + tmpPragmaticsSize;
                            }
                            if (tmpPragmaticsBold) {
                                style += 'font-weight: bold;';
                            }
                            if (tmpPragmaticsItalic) {
                                style += 'font-style: italic;';
                            }
                            if (tmpPragmaticsUnderline) {
                                style += 'text-decoration: underline;';
                            }
                        }
                        resultAllText += '<span style="' + style + '">' + json[i].word + '</span>';
                    } else {
                        resultAllText += json[i].word;
                    }
                } else if (tmpPhrasalVerbsFilterActive) {
                    if (json[i].phrasalverb == 'PhrV') {
                        applyFormatToPos = true;
                        if (applyFormatToPos) {
                            if (tmpPhrasalVerbsColor) {
                                style += 'color:' + decodeColor(tmpPhrasalVerbsColor) + ';';
                            }
                            if (tmpPhrasalVerbsSize) {
                                style += 'font-size:' + decodeSize(tmpPhrasalVerbsSize) + ';';
                                classProps = 'text-' + tmpPhrasalVerbsSize;
                            }
                            if (tmpPhrasalVerbsBold) {
                                style += 'font-weight: bold;';
                            }
                            if (tmpPhrasalVerbsItalic) {
                                style += 'font-style: italic;';
                            }
                            if (tmpPhrasalVerbsUnderline) {
                                style += 'text-decoration: underline;';
                            }
                        }
                        resultAllText += '<span style="' + style + '">' + json[i].word + '</span>';
                    } else {
                        resultAllText += json[i].word;
                    }
                } else {
                    // Russian uses UPOS tags instead of XPOS
                    const upos = json[i].upos;
                    const features = json[i].features || '';

                    if (upos === 'NOUN' && tmpNounsFilterActive) {
                        // Nouns
                        if (tmpNounsFilterOption == 'all') {
                            applyFormatToPos = true;
                        } else if (tmpNounsFilterOption == 'gender') {
                            applyFormatToPos = (
                                (tmpNounsGenderChecked.fem && hasFeature(features, 'Gender', 'Fem')) ||
                                (tmpNounsGenderChecked.masc && hasFeature(features, 'Gender', 'Masc')) ||
                                (tmpNounsGenderChecked.neut && hasFeature(features, 'Gender', 'Neut'))
                            );
                        } else if (tmpNounsFilterOption == 'animacy') {
                            applyFormatToPos = (
                                (tmpNounsAnimacyChecked.anim && hasFeature(features, 'Animacy', 'Anim')) ||
                                (tmpNounsAnimacyChecked.inan && hasFeature(features, 'Animacy', 'Inan'))
                            );
                        } else if (tmpNounsFilterOption == 'number') {
                            applyFormatToPos = (
                                (tmpNounsNumberChecked.sing && hasFeature(features, 'Number', 'Sing')) ||
                                (tmpNounsNumberChecked.plur && hasFeature(features, 'Number', 'Plur'))
                            );
                        } else if (tmpNounsFilterOption == 'case') {
                            applyFormatToPos = (
                                (tmpNounsCaseChecked.nom && hasFeature(features, 'Case', 'Nom')) ||
                                (tmpNounsCaseChecked.gen && hasFeature(features, 'Case', 'Gen')) ||
                                (tmpNounsCaseChecked.acc && hasFeature(features, 'Case', 'Acc')) ||
                                (tmpNounsCaseChecked.dat && hasFeature(features, 'Case', 'Dat')) ||
                                (tmpNounsCaseChecked.ins && hasFeature(features, 'Case', 'Ins')) ||
                                (tmpNounsCaseChecked.loc && hasFeature(features, 'Case', 'Loc'))
                            );
                        } else {
                            applyFormatToPos = false;
                        }
                        if (applyFormatToPos) {
                            if (tmpNounsColor) {
                                style += 'color:' + decodeColor(tmpNounsColor) + ';';
                            }
                            if (tmpNounsSize) {
                                style += 'font-size:' + decodeSize(tmpNounsSize) + ';';
                                classProps = 'text-' + tmpNounsSize;
                            }
                            if (tmpNounsBold) {
                                style += 'font-weight: bold;';
                            }
                            if (tmpNounsItalic) {
                                style += 'font-style: italic;';
                            }
                            if (tmpNounsUnderline) {
                                style += 'text-decoration: underline;';
                            }
                            // Only apply formatting if there's actual formatting selected
                            if (tmpNounsColor || tmpNounsSize || tmpNounsBold || tmpNounsItalic || tmpNounsUnderline) {
                                resultAllText += classProps ? '<span class="' + classProps + '" style="' + style + '">' + json[i].word + '</span>' : '<span style="' + style + '">' + json[i].word + '</span>';
                            } else {
                                resultAllText += json[i].word;
                            }
                        } else {
                            resultAllText += json[i].word;
                        }
                    } else if (upos === 'PROPN' && tmpProperNounsFilterActive) {
                        // Proper Nouns
                        if (tmpProperNounsFilterOption == 'all') {
                            applyFormatToPos = true;
                        } else if (tmpProperNounsFilterOption == 'gender') {
                            applyFormatToPos = (
                                (tmpProperNounsGenderChecked.fem && hasFeature(features, 'Gender', 'Fem')) ||
                                (tmpProperNounsGenderChecked.masc && hasFeature(features, 'Gender', 'Masc')) ||
                                (tmpProperNounsGenderChecked.neut && hasFeature(features, 'Gender', 'Neut'))
                            );
                        } else if (tmpProperNounsFilterOption == 'animacy') {
                            applyFormatToPos = (
                                (tmpProperNounsAnimacyChecked.anim && hasFeature(features, 'Animacy', 'Anim')) ||
                                (tmpProperNounsAnimacyChecked.inan && hasFeature(features, 'Animacy', 'Inan'))
                            );
                        } else if (tmpProperNounsFilterOption == 'number') {
                            applyFormatToPos = (
                                (tmpProperNounsNumberChecked.sing && hasFeature(features, 'Number', 'Sing')) ||
                                (tmpProperNounsNumberChecked.plur && hasFeature(features, 'Number', 'Plur'))
                            );
                        } else if (tmpProperNounsFilterOption == 'case') {
                            applyFormatToPos = (
                                (tmpProperNounsCaseChecked.nom && hasFeature(features, 'Case', 'Nom')) ||
                                (tmpProperNounsCaseChecked.gen && hasFeature(features, 'Case', 'Gen')) ||
                                (tmpProperNounsCaseChecked.acc && hasFeature(features, 'Case', 'Acc')) ||
                                (tmpProperNounsCaseChecked.dat && hasFeature(features, 'Case', 'Dat')) ||
                                (tmpProperNounsCaseChecked.ins && hasFeature(features, 'Case', 'Ins')) ||
                                (tmpProperNounsCaseChecked.loc && hasFeature(features, 'Case', 'Loc'))
                            );
                        } else {
                            applyFormatToPos = false;
                        }
                        if (applyFormatToPos) {
                            if (tmpProperNounsColor) {
                                style += 'color:' + decodeColor(tmpProperNounsColor) + ';';
                            }
                            if (tmpProperNounsSize) {
                                style += 'font-size:' + decodeSize(tmpProperNounsSize) + ';';
                                classProps = 'text-' + tmpProperNounsSize;
                            }
                            if (tmpProperNounsBold) {
                                style += 'font-weight: bold;';
                            }
                            if (tmpProperNounsItalic) {
                                style += 'font-style: italic;';
                            }
                            if (tmpProperNounsUnderline) {
                                style += 'text-decoration: underline;';
                            }
                            // Only apply formatting if there's actual formatting selected
                            if (tmpProperNounsColor || tmpProperNounsSize || tmpProperNounsBold || tmpProperNounsItalic || tmpProperNounsUnderline) {
                                resultAllText += classProps ? '<span class="' + classProps + '" style="' + style + '">' + json[i].word + '</span>' : '<span style="' + style + '">' + json[i].word + '</span>';
                            } else {
                                resultAllText += json[i].word;
                            }
                        } else {
                            resultAllText += json[i].word;
                        }
                    } else if (upos === 'NUM' && tmpNumeralsFilterActive) {
                        // Numerals
                        if (tmpNumeralsFilterOption == 'all') {
                            applyFormatToPos = true;
                        } else if (tmpNumeralsFilterOption == 'gender') {
                            applyFormatToPos = (
                                (tmpNumeralsGenderChecked.fem && hasFeature(features, 'Gender', 'Fem')) ||
                                (tmpNumeralsGenderChecked.masc && hasFeature(features, 'Gender', 'Masc')) ||
                                (tmpNumeralsGenderChecked.neut && hasFeature(features, 'Gender', 'Neut'))
                            );
                        } else if (tmpNumeralsFilterOption == 'number') {
                            applyFormatToPos = (
                                (tmpNumeralsNumberChecked.sing && hasFeature(features, 'Number', 'Sing')) ||
                                (tmpNumeralsNumberChecked.plur && hasFeature(features, 'Number', 'Plur'))
                            );
                        } else if (tmpNumeralsFilterOption == 'case') {
                            applyFormatToPos = (
                                (tmpNumeralsCaseChecked.nom && hasFeature(features, 'Case', 'Nom')) ||
                                (tmpNumeralsCaseChecked.gen && hasFeature(features, 'Case', 'Gen')) ||
                                (tmpNumeralsCaseChecked.acc && hasFeature(features, 'Case', 'Acc')) ||
                                (tmpNumeralsCaseChecked.dat && hasFeature(features, 'Case', 'Dat')) ||
                                (tmpNumeralsCaseChecked.ins && hasFeature(features, 'Case', 'Ins')) ||
                                (tmpNumeralsCaseChecked.loc && hasFeature(features, 'Case', 'Loc'))
                            );
                        } else if (tmpNumeralsFilterOption == 'numtype') {
                            applyFormatToPos = (
                                (tmpNumeralsNumTypeChecked.card && hasFeature(features, 'NumType', 'Card'))
                            );
                        } else {
                            applyFormatToPos = false;
                        }
                        if (applyFormatToPos) {
                            if (tmpNumeralsColor) {
                                style += 'color:' + decodeColor(tmpNumeralsColor) + ';';
                            }
                            if (tmpNumeralsSize) {
                                style += 'font-size:' + decodeSize(tmpNumeralsSize) + ';';
                                classProps = 'text-' + tmpNumeralsSize;
                            }
                            if (tmpNumeralsBold) {
                                style += 'font-weight: bold;';
                            }
                            if (tmpNumeralsItalic) {
                                style += 'font-style: italic;';
                            }
                            if (tmpNumeralsUnderline) {
                                style += 'text-decoration: underline;';
                            }
                            // Only apply formatting if there's actual formatting selected
                            if (tmpNumeralsColor || tmpNumeralsSize || tmpNumeralsBold || tmpNumeralsItalic || tmpNumeralsUnderline) {
                                resultAllText += classProps ? '<span class="' + classProps + '" style="' + style + '">' + json[i].word + '</span>' : '<span style="' + style + '">' + json[i].word + '</span>';
                            } else {
                                resultAllText += json[i].word;
                            }
                        } else {
                            resultAllText += json[i].word;
                        }
                    } else if (upos === 'ADJ' && tmpAdjectivesFilterActive) {
                        // Adjectives
                        switch (tmpAdjectivesFilterOption) {
                            case 'gender':
                                // Check if any gender checkbox is selected and matches
                                if ((tmpAdjectivesGenderChecked.fem && hasFeature(features, 'Gender', 'Fem')) ||
                                    (tmpAdjectivesGenderChecked.masc && hasFeature(features, 'Gender', 'Masc')) ||
                                    (tmpAdjectivesGenderChecked.neut && hasFeature(features, 'Gender', 'Neut'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'animacy':
                                // Check if any animacy checkbox is selected and matches
                                if ((tmpAdjectivesAnimacyChecked.anim && hasFeature(features, 'Animacy', 'Anim')) ||
                                    (tmpAdjectivesAnimacyChecked.inan && hasFeature(features, 'Animacy', 'Inan'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'number':
                                // Check if any number checkbox is selected and matches
                                if ((tmpAdjectivesNumberChecked.sing && hasFeature(features, 'Number', 'Sing')) ||
                                    (tmpAdjectivesNumberChecked.plur && hasFeature(features, 'Number', 'Plur'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'case':
                                // Check if any case checkbox is selected and matches
                                if ((tmpAdjectivesCaseChecked.nom && hasFeature(features, 'Case', 'Nom')) ||
                                    (tmpAdjectivesCaseChecked.gen && hasFeature(features, 'Case', 'Gen')) ||
                                    (tmpAdjectivesCaseChecked.acc && hasFeature(features, 'Case', 'Acc')) ||
                                    (tmpAdjectivesCaseChecked.dat && hasFeature(features, 'Case', 'Dat')) ||
                                    (tmpAdjectivesCaseChecked.ins && hasFeature(features, 'Case', 'Ins')) ||
                                    (tmpAdjectivesCaseChecked.loc && hasFeature(features, 'Case', 'Loc'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'degree':
                                // Check if any degree checkbox is selected and matches
                                if ((tmpAdjectivesDegreeChecked.pos && hasFeature(features, 'Degree', 'Pos')) ||
                                    (tmpAdjectivesDegreeChecked.cmp && hasFeature(features, 'Degree', 'Cmp')) ||
                                    (tmpAdjectivesDegreeChecked.sup && hasFeature(features, 'Degree', 'Sup'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'form':
                                // Check if form checkbox is selected and matches
                                if (tmpAdjectivesFormChecked.short && hasFeature(features, 'Form', 'Short')) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'all':
                                applyFormatToPos = true;
                                break;
                        }
                        if (applyFormatToPos) {
                            if (tmpAdjectivesColor || tmpAdjectivesSize || tmpAdjectivesBold || tmpAdjectivesItalic || tmpAdjectivesUnderline) {
                                if (tmpAdjectivesColor) {
                                    style += 'color:' + decodeColor(tmpAdjectivesColor) + ';';
                                }
                                if (tmpAdjectivesSize) {
                                    style += 'font-size:' + decodeSize(tmpAdjectivesSize) + ';';
                                    classProps = 'text-' + tmpAdjectivesSize;
                                }
                                if (tmpAdjectivesBold) {
                                    style += 'font-weight: bold;';
                                }
                                if (tmpAdjectivesItalic) {
                                    style += 'font-style: italic;';
                                }
                                if (tmpAdjectivesUnderline) {
                                    style += 'text-decoration: underline;';
                                }
                                resultAllText += classProps ? '<span class="' + classProps + '" style="' + style + '">' + json[i].word + '</span>' : '<span style="' + style + '">' + json[i].word + '</span>';
                            } else {
                                resultAllText += json[i].word;
                            }
                        } else {
                            resultAllText += json[i].word;
                        }
                    } else if (upos === 'ADV') {
                        // Adverbs
                        switch (tmpAdverbsFilterOption) {
                            case 'degree':
                                // Check if any degree checkbox is selected and matches
                                if ((tmpAdverbsDegreeChecked.cmp && hasFeature(features, 'Degree', 'Cmp')) ||
                                    (tmpAdverbsDegreeChecked.sup && hasFeature(features, 'Degree', 'Sup'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'all':
                                applyFormatToPos = true;
                                break;
                        }
                        if (applyFormatToPos) {
                            if (tmpAdverbsColor || tmpAdverbsSize || tmpAdverbsBold || tmpAdverbsItalic || tmpAdverbsUnderline) {
                                if (tmpAdverbsColor) {
                                    style += 'color:' + decodeColor(tmpAdverbsColor) + ';';
                                }
                                if (tmpAdverbsSize) {
                                    style += 'font-size:' + decodeSize(tmpAdverbsSize) + ';';
                                    classProps = 'text-' + tmpAdverbsSize;
                                }
                                if (tmpAdverbsBold) {
                                    style += 'font-weight: bold;';
                                }
                                if (tmpAdverbsItalic) {
                                    style += 'font-style: italic;';
                                }
                                if (tmpAdverbsUnderline) {
                                    style += 'text-decoration: underline;';
                                }
                                resultAllText += classProps ? '<span class="' + classProps + '" style="' + style + '">' + json[i].word + '</span>' : '<span style="' + style + '">' + json[i].word + '</span>';
                            } else {
                                resultAllText += json[i].word;
                            }
                        } else {
                            resultAllText += json[i].word;
                        }
                    } else if (upos === 'VERB') {
                        // Verbs
                        switch (tmpVerbsFilterOption) {
                            case 'aspect':
                                // Check if any aspect checkbox is selected and matches
                                if ((tmpVerbsAspectChecked.imp && hasFeature(features, 'Aspect', 'Imp')) ||
                                    (tmpVerbsAspectChecked.perf && hasFeature(features, 'Aspect', 'Perf'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'tense':
                                // Check if any tense checkbox is selected and matches
                                if ((tmpVerbsTenseChecked.past && hasFeature(features, 'Tense', 'Past')) ||
                                    (tmpVerbsTenseChecked.pres && hasFeature(features, 'Tense', 'Pres')) ||
                                    (tmpVerbsTenseChecked.fut && hasFeature(features, 'Tense', 'Fut'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'mood':
                                // Check if any mood checkbox is selected and matches
                                if ((tmpVerbsMoodChecked.ind && hasFeature(features, 'Mood', 'Ind')) ||
                                    (tmpVerbsMoodChecked.cnd && hasFeature(features, 'Mood', 'Cnd')) ||
                                    (tmpVerbsMoodChecked.imp && hasFeature(features, 'Mood', 'Imp'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'gender':
                                // Check if any gender checkbox is selected and matches
                                if ((tmpVerbsGenderChecked.fem && hasFeature(features, 'Gender', 'Fem')) ||
                                    (tmpVerbsGenderChecked.masc && hasFeature(features, 'Gender', 'Masc')) ||
                                    (tmpVerbsGenderChecked.neut && hasFeature(features, 'Gender', 'Neut'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'number':
                                // Check if any number checkbox is selected and matches
                                if ((tmpVerbsNumberChecked.sing && hasFeature(features, 'Number', 'Sing')) ||
                                    (tmpVerbsNumberChecked.plur && hasFeature(features, 'Number', 'Plur'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'person':
                                // Check if any person checkbox is selected and matches
                                if ((tmpVerbsPersonChecked.first && hasFeature(features, 'Person', '3')) ||
                                    (tmpVerbsPersonChecked.second && hasFeature(features, 'Person', '2')) ||
                                    (tmpVerbsPersonChecked.third && hasFeature(features, 'Person', '1'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'verbform':
                                // Check if any verbform checkbox is selected and matches
                                if ((tmpVerbsVerbFormChecked.fin && hasFeature(features, 'VerbForm', 'Fin')) ||
                                    (tmpVerbsVerbFormChecked.inf && hasFeature(features, 'VerbForm', 'Inf')) ||
                                    (tmpVerbsVerbFormChecked.conv && hasFeature(features, 'VerbForm', 'Conv')) ||
                                    (tmpVerbsVerbFormChecked.part && hasFeature(features, 'VerbForm', 'Part'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'voice':
                                // Check if any voice checkbox is selected and matches
                                if ((tmpVerbsVoiceChecked.act && hasFeature(features, 'Voice', 'Act')) ||
                                    (tmpVerbsVoiceChecked.mid && hasFeature(features, 'Voice', 'Mid')) ||
                                    (tmpVerbsVoiceChecked.pass && hasFeature(features, 'Voice', 'Pass'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'all':
                                applyFormatToPos = true;
                                break;
                        }
                        if (applyFormatToPos) {
                            if (tmpVerbsColor || tmpVerbsSize || tmpVerbsBold || tmpVerbsItalic || tmpVerbsUnderline) {
                                if (tmpVerbsColor) {
                                    style += 'color:' + decodeColor(tmpVerbsColor) + ';';
                                }
                                if (tmpVerbsSize) {
                                    style += 'font-size:' + decodeSize(tmpVerbsSize) + ';';
                                    classProps = 'text-' + tmpVerbsSize;
                                }
                                if (tmpVerbsBold) {
                                    style += 'font-weight: bold;';
                                }
                                if (tmpVerbsItalic) {
                                    style += 'font-style: italic;';
                                }
                                if (tmpVerbsUnderline) {
                                    style += 'text-decoration: underline;';
                                }
                                resultAllText += classProps ? '<span class="' + classProps + '" style="' + style + '">' + json[i].word + '</span>' : '<span style="' + style + '">' + json[i].word + '</span>';
                            } else {
                                resultAllText += json[i].word;
                            }
                        } else {
                            resultAllText += json[i].word;
                        }
                    } else if (upos === 'ADP') {
                        // Prepositions
                        applyFormatToPos = true;
                        if (applyFormatToPos) {
                            if (tmpPrepositionsColor) {
                                style += 'color:' + decodeColor(tmpPrepositionsColor) + ';';
                            }
                            if (tmpPrepositionsSize) {
                                style += 'font-size:' + decodeSize(tmpPrepositionsSize) + ';';
                                classProps = 'text-' + tmpPrepositionsSize;
                            }
                            if (tmpPrepositionsBold) {
                                style += 'font-weight: bold;';
                            }
                            if (tmpPrepositionsItalic) {
                                style += 'font-style: italic;';
                            }
                            if (tmpPrepositionsUnderline) {
                                style += 'text-decoration: underline;';
                            }
                            resultAllText += '<span class="' + classProps + '" style="' + style + '">' + json[i].word + '</span>';
                        } else {
                            resultAllText += json[i].word;
                        }
                    } else if (upos === 'SCONJ') {
                        // Subordinating Conjunctions
                        applyFormatToPos = true;
                        if (applyFormatToPos) {
                            if (tmpSubConjunctionsColor) {
                                style += 'color:' + decodeColor(tmpSubConjunctionsColor) + ';';
                            }
                            if (tmpSubConjunctionsSize) {
                                style += 'font-size:' + decodeSize(tmpSubConjunctionsSize) + ';';
                                classProps = 'text-' + tmpSubConjunctionsSize;
                            }
                            if (tmpSubConjunctionsBold) {
                                style += 'font-weight: bold;';
                            }
                            if (tmpSubConjunctionsItalic) {
                                style += 'font-style: italic;';
                            }
                            if (tmpSubConjunctionsUnderline) {
                                style += 'text-decoration: underline;';
                            }
                            resultAllText += '<span class="' + classProps + '" style="' + style + '">' + json[i].word + '</span>';
                        } else {
                            resultAllText += json[i].word;
                        }
                    } else if (upos === 'PRON') {
                        // Pronouns
                        switch (tmpPronounsFilterOption) {
                            case 'gender':
                                // Check if any gender checkbox is selected and matches
                                if ((tmpPronounsGenderChecked.fem && hasFeature(features, 'Gender', 'Fem')) ||
                                    (tmpPronounsGenderChecked.masc && hasFeature(features, 'Gender', 'Masc')) ||
                                    (tmpPronounsGenderChecked.neut && hasFeature(features, 'Gender', 'Neut'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'animacy':
                                // Check if any animacy checkbox is selected and matches
                                if ((tmpPronounsAnimacyChecked.anim && hasFeature(features, 'Animacy', 'Anim')) ||
                                    (tmpPronounsAnimacyChecked.inan && hasFeature(features, 'Animacy', 'Inan'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'number':
                                // Check if any number checkbox is selected and matches
                                if ((tmpPronounsNumberChecked.sing && hasFeature(features, 'Number', 'Sing')) ||
                                    (tmpPronounsNumberChecked.plur && hasFeature(features, 'Number', 'Plur'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'case':
                                // Check if any case checkbox is selected and matches
                                if ((tmpPronounsCaseChecked.nom && hasFeature(features, 'Case', 'Nom')) ||
                                    (tmpPronounsCaseChecked.gen && hasFeature(features, 'Case', 'Gen')) ||
                                    (tmpPronounsCaseChecked.acc && hasFeature(features, 'Case', 'Acc')) ||
                                    (tmpPronounsCaseChecked.dat && hasFeature(features, 'Case', 'Dat')) ||
                                    (tmpPronounsCaseChecked.ins && hasFeature(features, 'Case', 'Ins')) ||
                                    (tmpPronounsCaseChecked.loc && hasFeature(features, 'Case', 'Loc'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'person':
                                // Check if any person checkbox is selected and matches
                                if ((tmpPronounsPersonChecked.first && hasFeature(features, 'Person', '1')) ||
                                    (tmpPronounsPersonChecked.second && hasFeature(features, 'Person', '2')) ||
                                    (tmpPronounsPersonChecked.third && hasFeature(features, 'Person', '3'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'prontype':
                                // Check if any prontype checkbox is selected and matches
                                if ((tmpPronounsPronTypeChecked.prs && hasFeature(features, 'PronType', 'Prs')) ||
                                    (tmpPronounsPronTypeChecked.ind && hasFeature(features, 'PronType', 'Ind')) ||
                                    (tmpPronounsPronTypeChecked.dem && hasFeature(features, 'PronType', 'Dem'))) {
                                    applyFormatToPos = true;
                                }
                                break;
                            case 'all':
                                applyFormatToPos = true;
                                break;
                        }
                        if (applyFormatToPos) {
                            if (tmpPronounsColor) {
                                style += 'color:' + decodeColor(tmpPronounsColor) + ';';
                            }
                            if (tmpPronounsSize) {
                                style += 'font-size:' + decodeSize(tmpPronounsSize) + ';';
                                classProps = 'text-' + tmpPronounsSize;
                            }
                            if (tmpPronounsBold) {
                                style += 'font-weight: bold;';
                            }
                            if (tmpPronounsItalic) {
                                style += 'font-style: italic;';
                            }
                            if (tmpPronounsUnderline) {
                                style += 'text-decoration: underline;';
                            }
                            resultAllText += '<span class="' + classProps + '" style="' + style + '">' + json[i].word + '</span>';
                        } else {
                            resultAllText += json[i].word;
                        }
                    } else if (upos === 'CCONJ') {
                        // Coordinating Conjunctions
                        applyFormatToPos = true;
                        if (applyFormatToPos) {
                            if (tmpConjunctionsColor) {
                                style += 'color:' + decodeColor(tmpConjunctionsColor) + ';';
                            }
                            if (tmpConjunctionsSize) {
                                style += 'font-size:' + decodeSize(tmpConjunctionsSize) + ';';
                                classProps = 'text-' + tmpConjunctionsSize;
                            }
                            if (tmpConjunctionsBold) {
                                style += 'font-weight: bold;';
                            }
                            if (tmpConjunctionsItalic) {
                                style += 'font-style: italic;';
                            }
                            if (tmpConjunctionsUnderline) {
                                style += 'text-decoration: underline;';
                            }
                            resultAllText += '<span class="' + classProps + '" style="' + style + '">' + json[i].word + '</span>';
                        } else {
                            resultAllText += json[i].word;
                        }
                    } else if (upos === 'NUM') {
                        // Numerals - can be highlighted if needed in the future
                        resultAllText += json[i].word;
                    } else if (upos === 'PART') {
                        // Particles
                        applyFormatToPos = true;
                        if (applyFormatToPos) {
                            if (tmpParticlesColor || tmpParticlesSize || tmpParticlesBold || tmpParticlesItalic || tmpParticlesUnderline) {
                                if (tmpParticlesColor) {
                                    style += 'color:' + decodeColor(tmpParticlesColor) + ';';
                                }
                                if (tmpParticlesSize) {
                                    style += 'font-size:' + decodeSize(tmpParticlesSize) + ';';
                                    classProps = 'text-' + tmpParticlesSize;
                                }
                                if (tmpParticlesBold) {
                                    style += 'font-weight: bold;';
                                }
                                if (tmpParticlesItalic) {
                                    style += 'font-style: italic;';
                                }
                                if (tmpParticlesUnderline) {
                                    style += 'text-decoration: underline;';
                                }
                                resultAllText += classProps ? '<span class="' + classProps + '" style="' + style + '">' + json[i].word + '</span>' : '<span style="' + style + '">' + json[i].word + '</span>';
                            } else {
                                resultAllText += json[i].word;
                            }
                        } else {
                            resultAllText += json[i].word;
                        }
                    } else if (upos === 'PUNCT') {
                        // Punctuation marks - usually not highlighted
                        resultAllText += json[i].word;
                    } else {
                        // Default: other word types (SYM, X, etc.)
                        resultAllText += json[i].word;
                    }
                }
                prevEndChar = json[i].end_char;
            }
            resultAllText += '</p>';
        }
        setAllText(resultAllText);
        props.saveFormattedTextCallback(resultAllText);
    }

    // Helper function to parse features string (e.g., "Animacy=Inan|Case=Nom|Gender=Fem|Number=Plur")
    const hasFeature = (featuresStr: string, featureName: string, featureValue: string) => {
        if (!featuresStr || featuresStr === '_' || featuresStr === 'NoFeats') return false;
        const features = featuresStr.split('|');
        return features.some(f => f === `${featureName}=${featureValue}`);
    }

    const getTenseFrequency = (tenses: any, t: string) => {
        let value = 0;
        // Russian analyzer might not return tense data
        if (!tenses || !Array.isArray(tenses)) {
            return value;
        }
        const index = tenses.findIndex((tense: any) => tense.tense == t);
        if (index !== -1) {
            value = tenses[index].frequency;
        }

        return value;
    }

    const getPragmaticFrequency = (pragmatics: any, p: string) => {
        let value = 0;
        // Russian analyzer doesn't return pragmatics data
        if (!pragmatics || !Array.isArray(pragmatics)) {
            return value;
        }
        const index = pragmatics.findIndex((pragmatic: any) => pragmatic.pragmatics == p);
        if (index !== -1) {
            value = pragmatics[index].frequency;
        }

        return value;
    }

    const getPhrasalFrequency = (phrasals: any, f: string) => {
        let value = 0;
        // Russian analyzer doesn't return phrasal verbs data
        if (!phrasals || !Array.isArray(phrasals)) {
            return value;
        }
        const index = phrasals.findIndex((phrasal: any) => phrasal.phrasalverbs == f);
        if (index !== -1) {
            value = phrasals[index].frequency;
        }

        return value;
    }

    useEffect(() => {
        if (props.analyzedText.main && props.analyzedText.main.length == 0 && 
            props.analyzedText.countPhrasals && props.analyzedText.countPhrasals.length == 0 && 
            props.analyzedText.countTense && props.analyzedText.countTense.length == 0 && 
            props.analyzedText.countPragmatics && props.analyzedText.countPragmatics.length == 0) {
            setProcessingEmpty(true);
        } else {
            setProcessingEmpty(false);
            const newNlpCategories = {
                pragmaticsAll: getPragmaticFrequency(props.analyzedText.countPragmatics, 'Suggestion_Direct') + 
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Suggestion_Conventionalised') + 
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Suggestion_Indirect') +
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Thanking_Informal') + 
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Thanking_Conventionalised') + 
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Thanking_Formal') +
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Request_Direct') +
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Request_Conventionalised') +
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Request_Indirect') +
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Agreeing/Disagreeing_Informal') +
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Agreeing/Disagreeing_Formal') +
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Showing_Interest_Informal') +
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Showing_Interest_Formal') +
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Apologising_Conventionalised') + 
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Apologising_Informal') + 
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Apologising_Formal') +
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Giving_Opinion_Conventionalised') + 
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Giving_Opinion_Formal') +
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Greeting_Informal') +
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Greeting_Conventionalised') + 
                    getPragmaticFrequency(props.analyzedText.countPragmatics, 'Greeting_Formal'),
                pragmaticsSuggesting: getPragmaticFrequency(props.analyzedText.countPragmatics, 'Suggestion_Direct') + getPragmaticFrequency(props.analyzedText.countPragmatics, 'Suggestion_Conventionalised') + getPragmaticFrequency(props.analyzedText.countPragmatics, 'Suggestion_Indirect'),
                pragmaticsThanking: getPragmaticFrequency(props.analyzedText.countPragmatics, 'Thanking_Informal') + getPragmaticFrequency(props.analyzedText.countPragmatics, 'Thanking_Conventionalised') + getPragmaticFrequency(props.analyzedText.countPragmatics, 'Thanking_Formal'),
                pragmaticsRequesting: getPragmaticFrequency(props.analyzedText.countPragmatics, 'Request_Direct') + getPragmaticFrequency(props.analyzedText.countPragmatics, 'Request_Conventionalised') + getPragmaticFrequency(props.analyzedText.countPragmatics, 'Request_Indirect'),
                pragmaticsAgreeingDisagreeing: getPragmaticFrequency(props.analyzedText.countPragmatics, 'Agreeing/Disagreeing_Informal') + getPragmaticFrequency(props.analyzedText.countPragmatics, 'Agreeing/Disagreeing_Formal'),
                pragmaticsShowingInterest: getPragmaticFrequency(props.analyzedText.countPragmatics, 'Showing_Interest_Informal') + getPragmaticFrequency(props.analyzedText.countPragmatics, 'Showing_Interest_Formal'),
                pragmaticsApologising: getPragmaticFrequency(props.analyzedText.countPragmatics, 'Apologising_Conventionalised') + getPragmaticFrequency(props.analyzedText.countPragmatics, 'Apologising_Informal') + getPragmaticFrequency(props.analyzedText.countPragmatics, 'Apologising_Formal'),
                pragmaticsGivingAnOpinion: getPragmaticFrequency(props.analyzedText.countPragmatics, 'Giving_Opinion_Conventionalised') + getPragmaticFrequency(props.analyzedText.countPragmatics, 'Giving_Opinion_Formal'),
                pragmaticsGreeting: getPragmaticFrequency(props.analyzedText.countPragmatics, 'Greeting_Informal') + getPragmaticFrequency(props.analyzedText.countPragmatics, 'Greeting_Conventionalised') + getPragmaticFrequency(props.analyzedText.countPragmatics, 'Greeting_Formal'),
                phrasalVerbs: getPhrasalFrequency(props.analyzedText.countPhrasals, 'PhrV'),
                // Russian uses UPOS tags and features instead of XPOS
                nounsAll: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN').length,
                nounsIrregular: 0, // Russian doesn't have irregular plurals marked the same way
                // Common Nouns - Gender
                nounsGenderFem: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN' && hasFeature(c.features, 'Gender', 'Fem')).length,
                nounsGenderMasc: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN' && hasFeature(c.features, 'Gender', 'Masc')).length,
                nounsGenderNeut: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN' && hasFeature(c.features, 'Gender', 'Neut')).length,
                // Common Nouns - Animacy
                nounsAnimacyAnim: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN' && hasFeature(c.features, 'Animacy', 'Anim')).length,
                nounsAnimacyInan: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN' && hasFeature(c.features, 'Animacy', 'Inan')).length,
                // Common Nouns - Number
                nounsNumberSing: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN' && hasFeature(c.features, 'Number', 'Sing')).length,
                nounsNumberPlur: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN' && hasFeature(c.features, 'Number', 'Plur')).length,
                // Common Nouns - Case
                nounsCaseNom: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN' && hasFeature(c.features, 'Case', 'Nom')).length,
                nounsCaseGen: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN' && hasFeature(c.features, 'Case', 'Gen')).length,
                nounsCaseAcc: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN' && hasFeature(c.features, 'Case', 'Acc')).length,
                nounsCaseDat: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN' && hasFeature(c.features, 'Case', 'Dat')).length,
                nounsCaseIns: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN' && hasFeature(c.features, 'Case', 'Ins')).length,
                nounsCaseLoc: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN' && hasFeature(c.features, 'Case', 'Loc')).length,

                properNounsAll: props.analyzedText.main.filter((c: any) => c.upos === 'PROPN').length,
                // Proper Nouns - Gender
                properNounsGenderFem: props.analyzedText.main.filter((c: any) => c.upos === 'PROPN' && hasFeature(c.features, 'Gender', 'Fem')).length,
                properNounsGenderMasc: props.analyzedText.main.filter((c: any) => c.upos === 'PROPN' && hasFeature(c.features, 'Gender', 'Masc')).length,
                properNounsGenderNeut: props.analyzedText.main.filter((c: any) => c.upos === 'PROPN' && hasFeature(c.features, 'Gender', 'Neut')).length,
                // Proper Nouns - Animacy
                properNounsAnimacyAnim: props.analyzedText.main.filter((c: any) => c.upos === 'PROPN' && hasFeature(c.features, 'Animacy', 'Anim')).length,
                properNounsAnimacyInan: props.analyzedText.main.filter((c: any) => c.upos === 'PROPN' && hasFeature(c.features, 'Animacy', 'Inan')).length,
                // Proper Nouns - Number
                properNounsNumberSing: props.analyzedText.main.filter((c: any) => c.upos === 'PROPN' && hasFeature(c.features, 'Number', 'Sing')).length,
                properNounsNumberPlur: props.analyzedText.main.filter((c: any) => c.upos === 'PROPN' && hasFeature(c.features, 'Number', 'Plur')).length,
                // Proper Nouns - Case
                properNounsCaseNom: props.analyzedText.main.filter((c: any) => c.upos === 'PROPN' && hasFeature(c.features, 'Case', 'Nom')).length,
                properNounsCaseGen: props.analyzedText.main.filter((c: any) => c.upos === 'PROPN' && hasFeature(c.features, 'Case', 'Gen')).length,
                properNounsCaseAcc: props.analyzedText.main.filter((c: any) => c.upos === 'PROPN' && hasFeature(c.features, 'Case', 'Acc')).length,
                properNounsCaseDat: props.analyzedText.main.filter((c: any) => c.upos === 'PROPN' && hasFeature(c.features, 'Case', 'Dat')).length,
                properNounsCaseIns: props.analyzedText.main.filter((c: any) => c.upos === 'PROPN' && hasFeature(c.features, 'Case', 'Ins')).length,
                properNounsCaseLoc: props.analyzedText.main.filter((c: any) => c.upos === 'PROPN' && hasFeature(c.features, 'Case', 'Loc')).length,

                numeralsAll: props.analyzedText.main.filter((c: any) => c.upos === 'NUM').length,
                // Numerals - Gender
                numeralsGenderFem: props.analyzedText.main.filter((c: any) => c.upos === 'NUM' && hasFeature(c.features, 'Gender', 'Fem')).length,
                numeralsGenderMasc: props.analyzedText.main.filter((c: any) => c.upos === 'NUM' && hasFeature(c.features, 'Gender', 'Masc')).length,
                numeralsGenderNeut: props.analyzedText.main.filter((c: any) => c.upos === 'NUM' && hasFeature(c.features, 'Gender', 'Neut')).length,
                // Numerals - Number
                numeralsNumberSing: props.analyzedText.main.filter((c: any) => c.upos === 'NUM' && hasFeature(c.features, 'Number', 'Sing')).length,
                numeralsNumberPlur: props.analyzedText.main.filter((c: any) => c.upos === 'NUM' && hasFeature(c.features, 'Number', 'Plur')).length,
                // Numerals - Case
                numeralsCaseNom: props.analyzedText.main.filter((c: any) => c.upos === 'NUM' && hasFeature(c.features, 'Case', 'Nom')).length,
                numeralsCaseGen: props.analyzedText.main.filter((c: any) => c.upos === 'NUM' && hasFeature(c.features, 'Case', 'Gen')).length,
                numeralsCaseAcc: props.analyzedText.main.filter((c: any) => c.upos === 'NUM' && hasFeature(c.features, 'Case', 'Acc')).length,
                numeralsCaseDat: props.analyzedText.main.filter((c: any) => c.upos === 'NUM' && hasFeature(c.features, 'Case', 'Dat')).length,
                numeralsCaseIns: props.analyzedText.main.filter((c: any) => c.upos === 'NUM' && hasFeature(c.features, 'Case', 'Ins')).length,
                numeralsCaseLoc: props.analyzedText.main.filter((c: any) => c.upos === 'NUM' && hasFeature(c.features, 'Case', 'Loc')).length,
                // Numerals - NumType
                numeralsNumTypeCard: props.analyzedText.main.filter((c: any) => c.upos === 'NUM' && hasFeature(c.features, 'NumType', 'Card')).length,
                adjectivesAll: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ').length,
                // Adjectives - Gender
                adjectivesGenderFem: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && hasFeature(c.features, 'Gender', 'Fem')).length,
                adjectivesGenderMasc: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && hasFeature(c.features, 'Gender', 'Masc')).length,
                adjectivesGenderNeut: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && hasFeature(c.features, 'Gender', 'Neut')).length,
                // Adjectives - Animacy
                adjectivesAnimacyAnim: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && hasFeature(c.features, 'Animacy', 'Anim')).length,
                adjectivesAnimacyInan: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && hasFeature(c.features, 'Animacy', 'Inan')).length,
                // Adjectives - Number
                adjectivesNumberSing: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && hasFeature(c.features, 'Number', 'Sing')).length,
                adjectivesNumberPlur: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && hasFeature(c.features, 'Number', 'Plur')).length,
                // Adjectives - Case
                adjectivesCaseNom: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && hasFeature(c.features, 'Case', 'Nom')).length,
                adjectivesCaseGen: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && hasFeature(c.features, 'Case', 'Gen')).length,
                adjectivesCaseAcc: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && hasFeature(c.features, 'Case', 'Acc')).length,
                adjectivesCaseDat: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && hasFeature(c.features, 'Case', 'Dat')).length,
                adjectivesCaseIns: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && hasFeature(c.features, 'Case', 'Ins')).length,
                adjectivesCaseLoc: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && hasFeature(c.features, 'Case', 'Loc')).length,
                // Adjectives - Degree
                adjectivesPositive: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && hasFeature(c.features, 'Degree', 'Pos')).length,
                adjectivesComparative: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && hasFeature(c.features, 'Degree', 'Cmp')).length,
                adjectivesSuperlative: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && hasFeature(c.features, 'Degree', 'Sup')).length,
                // Adjectives - Form
                adjectivesFormShort: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && hasFeature(c.features, 'Form', 'Short')).length,
                adverbsAll: props.analyzedText.main.filter((c: any) => c.upos === 'ADV').length,
                adverbsComparative: props.analyzedText.main.filter((c: any) => c.upos === 'ADV' && hasFeature(c.features, 'Degree', 'Cmp')).length,
                adverbsSuperlative: props.analyzedText.main.filter((c: any) => c.upos === 'ADV' && hasFeature(c.features, 'Degree', 'Sup')).length,
                adverbsWh: 0, // Russian doesn't have wh-adverbs in the same way
                verbsAll: props.analyzedText.main.filter((c: any) => c.upos === 'VERB').length,
                verbsIrregular: 0, // Russian doesn't mark irregular verbs the same way
                // Verbs - Aspect
                verbsAspectImp: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Aspect', 'Imp')).length,
                verbsAspectPerf: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Aspect', 'Perf')).length,
                // Verbs - Mood
                verbsMoodInd: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Mood', 'Ind')).length,
                verbsMoodCnd: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Mood', 'Cnd')).length,
                verbsMoodImp: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Mood', 'Imp')).length,
                // Verbs - Tense
                verbsTensePast: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Tense', 'Past')).length,
                verbsTensePres: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Tense', 'Pres')).length,
                verbsTenseFut: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Tense', 'Fut')).length,
                // Verbs - Gender
                verbsGenderFem: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Gender', 'Fem')).length,
                verbsGenderMasc: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Gender', 'Masc')).length,
                verbsGenderNeut: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Gender', 'Neut')).length,
                // Verbs - Number
                verbsNumberSing: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Number', 'Sing')).length,
                verbsNumberPlur: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Number', 'Plur')).length,
                // Verbs - Person
                verbsPerson1: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Person', '1')).length,
                verbsPerson2: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Person', '2')).length,
                verbsPerson3: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Person', '3')).length,
                // Verbs - VerbForm
                verbsVerbFormFin: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'VerbForm', 'Fin')).length,
                verbsVerbFormInf: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'VerbForm', 'Inf')).length,
                verbsVerbFormConv: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'VerbForm', 'Conv')).length,
                verbsVerbFormPart: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'VerbForm', 'Part')).length,
                // Verbs - Voice
                verbsVoiceAct: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Voice', 'Act')).length,
                verbsVoiceMid: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Voice', 'Mid')).length,
                verbsVoicePass: props.analyzedText.main.filter((c: any) => c.upos === 'VERB' && hasFeature(c.features, 'Voice', 'Pass')).length,
                verbsTenseAll: getTenseFrequency(props.analyzedText.countTense, 'Present Simple') +
                    getTenseFrequency(props.analyzedText.countTense, 'Present Continuous') +
                    getTenseFrequency(props.analyzedText.countTense, 'Present Perfect') +
                    getTenseFrequency(props.analyzedText.countTense, 'Present Perfect Continuous') +
                    getTenseFrequency(props.analyzedText.countTense, 'Past Simple') +
                    getTenseFrequency(props.analyzedText.countTense, 'Past Continuous') +
                    getTenseFrequency(props.analyzedText.countTense, 'Past Perfect') +
                    getTenseFrequency(props.analyzedText.countTense, 'Past Perfect Continuous') +
                    getTenseFrequency(props.analyzedText.countTense, 'Future Be Going To') +
                    getTenseFrequency(props.analyzedText.countTense, 'Future Simple') +
                    getTenseFrequency(props.analyzedText.countTense, 'Future Perfect') +
                    getTenseFrequency(props.analyzedText.countTense, 'Future Perfect Continuous') +
                    getTenseFrequency(props.analyzedText.countTense, 'Present Simple Passive') +
                    getTenseFrequency(props.analyzedText.countTense, 'Present Continuous Passive') +
                    getTenseFrequency(props.analyzedText.countTense, 'Present Perfect Passive') +
                    getTenseFrequency(props.analyzedText.countTense, 'Present Perfect Continuous Passive') +
                    getTenseFrequency(props.analyzedText.countTense, 'Past Simple Passive') +
                    getTenseFrequency(props.analyzedText.countTense, 'Past Continuous Passive') +
                    getTenseFrequency(props.analyzedText.countTense, 'Past Perfect Passive') +
                    getTenseFrequency(props.analyzedText.countTense, 'Past Perfect Continuous Passive') +
                    getTenseFrequency(props.analyzedText.countTense, 'Future Simple Passive') +
                    getTenseFrequency(props.analyzedText.countTense, 'Future Perfect Passive') +
                    getTenseFrequency(props.analyzedText.countTense, 'Modal Verb') +
                    getTenseFrequency(props.analyzedText.countTense, 'Modal Perfect') +
                    getTenseFrequency(props.analyzedText.countTense, 'Modal Passive') + 
                    getTenseFrequency(props.analyzedText.countTense, 'Modal Perfect Passive') +
                    getTenseFrequency(props.analyzedText.countTense, 'Imperative'),
                verbsTensePresentSimple: getTenseFrequency(props.analyzedText.countTense, 'Present Simple'),
                verbsTensePresentContinuous: getTenseFrequency(props.analyzedText.countTense, 'Present Continuous'),
                verbsTensePresentPerfect: getTenseFrequency(props.analyzedText.countTense, 'Present Perfect'),
                verbsTensePresentPerfectContinuous: getTenseFrequency(props.analyzedText.countTense, 'Present Perfect Continuous'),
                verbsTensePastSimple: getTenseFrequency(props.analyzedText.countTense, 'Past Simple'),
                verbsTensePastContinuous: getTenseFrequency(props.analyzedText.countTense, 'Past Continuous'),
                verbsTensePastPerfect: getTenseFrequency(props.analyzedText.countTense, 'Past Perfect'),
                verbsTensePastPerfectContinuous: getTenseFrequency(props.analyzedText.countTense, 'Past Perfect Continuous'),
                verbsTenseFutureBeGoingTo: getTenseFrequency(props.analyzedText.countTense, 'Future Be Going To'),
                verbsTenseFutureSimple: getTenseFrequency(props.analyzedText.countTense, 'Future Simple'),
                verbsTenseFuturePerfect: getTenseFrequency(props.analyzedText.countTense, 'Future Perfect'),
                verbsTenseFuturePerfectContinuous: getTenseFrequency(props.analyzedText.countTense, 'Future Perfect Continuous'),
                verbsTensePresentSimplePassive: getTenseFrequency(props.analyzedText.countTense, 'Present Simple Passive'),
                verbsTensePresentContinuousPassive: getTenseFrequency(props.analyzedText.countTense, 'Present Continuous Passive'),
                verbsTensePresentPerfectPassive: getTenseFrequency(props.analyzedText.countTense, 'Present Perfect Passive'),
                verbsTensePresentPerfectContinuousPassive: getTenseFrequency(props.analyzedText.countTense, 'Present Perfect Continuous Passive'),
                verbsTensePastSimplePassive: getTenseFrequency(props.analyzedText.countTense, 'Past Simple Passive'),
                verbsTensePastContinuousPassive: getTenseFrequency(props.analyzedText.countTense, 'Past Continuous Passive'),
                verbsTensePastPerfectPassive: getTenseFrequency(props.analyzedText.countTense, 'Past Perfect Passive'),
                verbsTensePastPerfectContinuousPassive: getTenseFrequency(props.analyzedText.countTense, 'Past Perfect Continuous Passive'),
                verbsTenseFutureSimplePassive: getTenseFrequency(props.analyzedText.countTense, 'Future Simple Passive'),
                verbsTenseFuturePerfectPassive: getTenseFrequency(props.analyzedText.countTense, 'Future Perfect Passive'),
                verbsTenseModal: getTenseFrequency(props.analyzedText.countTense, 'Modal Verb') + getTenseFrequency(props.analyzedText.countTense, 'Modal Perfect') + getTenseFrequency(props.analyzedText.countTense, 'Modal Passive') + getTenseFrequency(props.analyzedText.countTense, 'Modal Perfect Passive'),
                verbsTenseImperative: getTenseFrequency(props.analyzedText.countTense, 'Imperative'),
                prepositionsAll: props.analyzedText.main.filter((c: any) => c.upos === 'ADP').length,
                subConjunctionsAll: props.analyzedText.main.filter((c: any) => c.upos === 'SCONJ').length,
                determinersAll: 0, // Russian doesn't have determiners like English
                determinersDeterminer: 0,
                determinersWh: 0,
                pronounsAll: props.analyzedText.main.filter((c: any) => c.upos === 'PRON').length,
                pronounsPersonal: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'PronType', 'Prs')).length,
                pronounsPossessive: 0, // Russian possessive pronouns are typically marked as ADJ
                pronounsPossessiveWh: 0,
                pronounsWh: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'PronType', 'Int,Rel')).length,
                // Pronouns - Gender
                pronounsGenderFem: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'Gender', 'Fem')).length,
                pronounsGenderMasc: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'Gender', 'Masc')).length,
                pronounsGenderNeut: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'Gender', 'Neut')).length,
                // Pronouns - Animacy
                pronounsAnimacyAnim: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'Animacy', 'Anim')).length,
                pronounsAnimacyInan: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'Animacy', 'Inan')).length,
                // Pronouns - Number
                pronounsNumberSing: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'Number', 'Sing')).length,
                pronounsNumberPlur: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'Number', 'Plur')).length,
                // Pronouns - Case
                pronounsCaseNom: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'Case', 'Nom')).length,
                pronounsCaseGen: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'Case', 'Gen')).length,
                pronounsCaseAcc: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'Case', 'Acc')).length,
                pronounsCaseDat: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'Case', 'Dat')).length,
                pronounsCaseIns: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'Case', 'Ins')).length,
                pronounsCaseLoc: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'Case', 'Loc')).length,
                // Pronouns - Person
                pronounsPerson1: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'Person', '1')).length,
                pronounsPerson2: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'Person', '2')).length,
                pronounsPerson3: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'Person', '3')).length,
                // Pronouns - PronType
                pronounsPronTypePrs: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'PronType', 'Prs')).length,
                pronounsPronTypeInd: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'PronType', 'Ind')).length,
                pronounsPronTypeDem: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'PronType', 'Dem')).length,
                pronounsPronTypeIntRel: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'PronType', 'Int,Rel')).length,
                pronounsPronTypeTot: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c.features, 'PronType', 'Tot')).length,
                conjunctionsAll: props.analyzedText.main.filter((c: any) => c.upos === 'CCONJ').length,
                particlesAll: props.analyzedText.main.filter((c: any) => c.upos === 'PART').length,
            };
            setNlpCategories(newNlpCategories);

            formatText(props.analyzedText.main,
                pragmaticsFilterActive, pragmaticsFilterOption, pragmaticsColor, pragmaticsSize, pragmaticsBold, pragmaticsItalic, pragmaticsUnderline,
                phrasalVerbsFilterActive, phrasalVerbsColor, phrasalVerbsSize, phrasalVerbsBold, phrasalVerbsItalic, phrasalVerbsUnderline,
                nounsFilterActive,
                nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
                nounsGenderChecked, nounsAnimacyChecked, nounsNumberChecked, nounsCaseChecked,
                properNounsFilterActive,
                properNounsFilterOption, properNounsColor, properNounsSize, properNounsBold, properNounsItalic, properNounsUnderline,
                properNounsGenderChecked, properNounsAnimacyChecked, properNounsNumberChecked, properNounsCaseChecked,
                numeralsFilterActive,
                numeralsFilterOption, numeralsColor, numeralsSize, numeralsBold, numeralsItalic, numeralsUnderline,
                numeralsGenderChecked, numeralsNumberChecked, numeralsCaseChecked, numeralsNumTypeChecked,
                adjectivesFilterActive, adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
                adjectivesGenderChecked, adjectivesAnimacyChecked, adjectivesNumberChecked, adjectivesCaseChecked, adjectivesDegreeChecked, adjectivesFormChecked,
                adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
                adverbsDegreeChecked,
                verbsFilterOption, verbTenseOptions, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
                verbsAspectChecked, verbsTenseChecked, verbsMoodChecked, verbsGenderChecked, verbsNumberChecked, verbsPersonChecked, verbsVerbFormChecked, verbsVoiceChecked,
                prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
                subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
                determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
                pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
                pronounsGenderChecked, pronounsAnimacyChecked, pronounsNumberChecked, pronounsCaseChecked, pronounsPersonChecked, pronounsPronTypeChecked,
                conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
        }
    }, []);

    return (
        <div className="processed-text-container">
            { processingEmpty && 
                <div className="empty-processed-text">
                    <Alert key={ 'warning' } variant={ 'warning' }>
                        { t("Sorry! The result of the text analysis is either empty or some errors were found. Revise and change your text and try it again.") }
                    </Alert>
                </div>
            }
            { !processingEmpty &&
                <div className="text-filters">
                    <Accordion defaultActiveKey="2">
                        {/* Pragmatic Expressions and Phrasal Verbs are not available for Russian */}
                        {/* <Accordion.Item eventKey="0">
                            <Accordion.Header>{ t("Pragmatic Expressions") }</Accordion.Header>
                            <Accordion.Body>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (pragmaticsFilterActive ? ' active' : '')}>
                                        <FormCheck name="pragmaticExpressions" type="checkbox" label={ t("Pragmatic Expressions") + ' (' + nlpCategories.pragmaticsAll + ')'}
                                            onChange={ handleChangePragmaticExpressions } checked={ pragmaticsFilterActive } />
                                    </div>
                                    { pragmaticsFilterActive &&
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('pragmatic', pragmaticsColor) }
                                                { sizeOptions('pragmatic', pragmaticsSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (pragmaticsBold ? ' active' : '') }
                                                        data-element="pragmatic" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (pragmaticsItalic ? ' active' : '') }
                                                        data-element="pragmatic" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (pragmaticsUnderline ? ' active' : '') }
                                                        data-element="pragmatic" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'pragmatics-all' } name={ 'pragmatics' }
                                                    label={ t("All pragmatic expressions") + ' (' + nlpCategories.pragmaticsAll + ')' } value={ 'all' } defaultChecked={ true }
                                                    onChange={ handlePragmaticsFilterOptionChange} />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'pragmatics-suggesting' } name={ 'pragmatics' }
                                                    label={ t("Suggesting") + ' (' + nlpCategories.pragmaticsSuggesting + ')' } value={ 'suggesting' }
                                                    onChange={ handlePragmaticsFilterOptionChange} />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'pragmatics-thanking' } name={ 'pragmatics' }
                                                    label={ t("Thanking") + ' (' + nlpCategories.pragmaticsThanking + ')' } value={ 'thanking' }
                                                    onChange={ handlePragmaticsFilterOptionChange} />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'pragmatics-requesting' } name={ 'pragmatics' }
                                                    label={ t("Requesting") + ' (' + nlpCategories.pragmaticsRequesting + ')' } value={ 'requesting' }
                                                    onChange={ handlePragmaticsFilterOptionChange} />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'pragmatics-agreeing-disagreeing' } name={ 'pragmatics' }
                                                    label={ t("Agreeing/Disagreeing") + ' (' + nlpCategories.pragmaticsAgreeingDisagreeing + ')' } value={ 'agreeing-disagreeing' }
                                                    onChange={ handlePragmaticsFilterOptionChange} />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'pragmatics-showing-interest' } name={ 'pragmatics' }
                                                    label={ t("Showing interest") + ' (' + nlpCategories.pragmaticsShowingInterest + ')' } value={ 'showing-interest' }
                                                    onChange={ handlePragmaticsFilterOptionChange} />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'pragmatics-apologising' } name={ 'pragmatics' }
                                                    label={ t("Apologising") + ' (' + nlpCategories.pragmaticsApologising + ')' } value={ 'apologising' }
                                                    onChange={ handlePragmaticsFilterOptionChange} />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'pragmatics-giving-an-opinion' } name={ 'pragmatics' }
                                                    label={ t("Giving an opinion") + ' (' + nlpCategories.pragmaticsGivingAnOpinion + ')' } value={ 'giving-an-opinion' }
                                                    onChange={ handlePragmaticsFilterOptionChange} />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'pragmatics-greeting' } name={ 'pragmatics' }
                                                    label={ t("Greeting") + ' (' + nlpCategories.pragmaticsGreeting + ')' } value={ 'greeting' }
                                                    onChange={ handlePragmaticsFilterOptionChange} />
                                            </div>
                                        </div>
                                    }
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>{ t("Phrasal verbs") }</Accordion.Header>
                            <Accordion.Body>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (phrasalVerbsFilterActive ? ' active' : '')}>
                                        <FormCheck name="phrasalVerbs" type="checkbox" label={ t("Phrasal verbs") + ' (' + nlpCategories.phrasalVerbs + ')'}
                                            onChange={ handleChangePhrasalVerbs } checked={ phrasalVerbsFilterActive } />
                                    </div>
                                    { phrasalVerbsFilterActive &&
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('phrasalVerbs', phrasalVerbsColor) }
                                                { sizeOptions('phrasalVerbs', phrasalVerbsSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (pragmaticsBold ? ' active' : '') }
                                                        data-element="phrasalVerbs" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (pragmaticsItalic ? ' active' : '') }
                                                        data-element="phrasalVerbs" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (pragmaticsUnderline ? ' active' : '') }
                                                        data-element="phrasalVerbs" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </Accordion.Body>
                        </Accordion.Item> */}
                        <Accordion.Item eventKey="2">
                            <Accordion.Header>{ t("Word Categories") }</Accordion.Header>
                            <Accordion.Body>
                                {/* Common Nouns (NOUN) */}
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (nounsFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'nouns' } label={ t("Common nouns") + ' (' + nlpCategories.nounsAll + ')' }
                                            onChange={ handleNounsFilterChange } checked={ nounsFilterActive } />
                                    </div>
                                    { nounsFilterActive &&
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('noun', nounsColor) }
                                                { sizeOptions('noun', nounsSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (nounsBold ? ' active' : '') }
                                                        data-element="noun" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (nounsItalic ? ' active' : '') }
                                                        data-element="noun" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (nounsUnderline ? ' active' : '') }
                                                        data-element="noun" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'nouns-all' } name={ 'nouns' }
                                                    label={ t("All common nouns") + ' (' + nlpCategories.nounsAll + ')' } value={ 'all' } defaultChecked={ true }
                                                    onChange={ handleNounsFilterOptionChange} />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'nouns-gender' } name={ 'nouns' }
                                                    label={ t("Gender") } value={ 'gender' }
                                                    onChange={ handleNounsFilterOptionChange} />
                                                { nounsFilterActive && nounsFilterOption == 'gender' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'nouns-gender-fem' }
                                                                label={ t("Feminine nouns") + ' (' + nlpCategories.nounsGenderFem + ')' } value={ 'fem' }
                                                                onChange={ handleNounsFilterOptionChange }
                                                                checked={ nounsGenderChecked.fem } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'nouns-gender-masc' }
                                                                label={ t("Masculine nouns") + ' (' + nlpCategories.nounsGenderMasc + ')' } value={ 'masc' }
                                                                onChange={ handleNounsFilterOptionChange }
                                                                checked={ nounsGenderChecked.masc } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'nouns-gender-neut' }
                                                                label={ t("Neuter nouns") + ' (' + nlpCategories.nounsGenderNeut + ')' } value={ 'neut' }
                                                                onChange={ handleNounsFilterOptionChange }
                                                                checked={ nounsGenderChecked.neut } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'nouns-animacy' } name={ 'nouns' }
                                                    label={ t("Animacy") } value={ 'animacy' }
                                                    onChange={ handleNounsFilterOptionChange} />
                                                { nounsFilterActive && nounsFilterOption == 'animacy' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'nouns-animacy-anim' }
                                                                label={ t("Animate nouns") + ' (' + nlpCategories.nounsAnimacyAnim + ')' } value={ 'anim' }
                                                                onChange={ handleNounsFilterOptionChange }
                                                                checked={ nounsAnimacyChecked.anim } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'nouns-animacy-inan' }
                                                                label={ t("Inanimate nouns") + ' (' + nlpCategories.nounsAnimacyInan + ')' } value={ 'inan' }
                                                                onChange={ handleNounsFilterOptionChange }
                                                                checked={ nounsAnimacyChecked.inan } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'nouns-number' } name={ 'nouns' }
                                                    label={ t("Number") } value={ 'number' }
                                                    onChange={ handleNounsFilterOptionChange} />
                                                { nounsFilterActive && nounsFilterOption == 'number' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'nouns-number-sing' }
                                                                label={ t("Singular nouns") + ' (' + nlpCategories.nounsNumberSing + ')' } value={ 'sing' }
                                                                onChange={ handleNounsFilterOptionChange }
                                                                checked={ nounsNumberChecked.sing } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'nouns-number-plur' }
                                                                label={ t("Plural nouns") + ' (' + nlpCategories.nounsNumberPlur + ')' } value={ 'plur' }
                                                                onChange={ handleNounsFilterOptionChange }
                                                                checked={ nounsNumberChecked.plur } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'nouns-case' } name={ 'nouns' }
                                                    label={ t("Case") } value={ 'case' }
                                                    onChange={ handleNounsFilterOptionChange} />
                                                { nounsFilterActive && nounsFilterOption == 'case' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'nouns-case-nom' }
                                                                label={ t("Nominative case") + ' (' + nlpCategories.nounsCaseNom + ')' } value={ 'nom' }
                                                                onChange={ handleNounsFilterOptionChange }
                                                                checked={ nounsCaseChecked.nom } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'nouns-case-gen' }
                                                                label={ t("Genitive case") + ' (' + nlpCategories.nounsCaseGen + ')' } value={ 'gen' }
                                                                onChange={ handleNounsFilterOptionChange }
                                                                checked={ nounsCaseChecked.gen } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'nouns-case-acc' }
                                                                label={ t("Accusative case") + ' (' + nlpCategories.nounsCaseAcc + ')' } value={ 'acc' }
                                                                onChange={ handleNounsFilterOptionChange }
                                                                checked={ nounsCaseChecked.acc } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'nouns-case-dat' }
                                                                label={ t("Dative case") + ' (' + nlpCategories.nounsCaseDat + ')' } value={ 'dat' }
                                                                onChange={ handleNounsFilterOptionChange }
                                                                checked={ nounsCaseChecked.dat } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'nouns-case-ins' }
                                                                label={ t("Instrumental case") + ' (' + nlpCategories.nounsCaseIns + ')' } value={ 'ins' }
                                                                onChange={ handleNounsFilterOptionChange }
                                                                checked={ nounsCaseChecked.ins } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'nouns-case-loc' }
                                                                label={ t("Prepositional case") + ' (' + nlpCategories.nounsCaseLoc + ')' } value={ 'loc' }
                                                                onChange={ handleNounsFilterOptionChange }
                                                                checked={ nounsCaseChecked.loc } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                                {/* Proper Nouns (PROPN) */}
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (properNounsFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'properNouns' } label={ t("Proper nouns") + ' (' + nlpCategories.properNounsAll + ')' }
                                            onChange={ handleProperNounsFilterChange } checked={ properNounsFilterActive } />
                                    </div>
                                    { properNounsFilterActive &&
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('propernoun', properNounsColor) }
                                                { sizeOptions('propernoun', properNounsSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (properNounsBold ? ' active' : '') }
                                                        data-element="propernoun" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (properNounsItalic ? ' active' : '') }
                                                        data-element="propernoun" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (properNounsUnderline ? ' active' : '') }
                                                        data-element="propernoun" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'propernouns-all' } name={ 'propernouns' }
                                                    label={ t("All proper nouns") + ' (' + nlpCategories.properNounsAll + ')' } value={ 'all' } defaultChecked={ true }
                                                    onChange={ handleProperNounsFilterOptionChange} />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'propernouns-gender' } name={ 'propernouns' }
                                                    label={ t("Gender") } value={ 'gender' }
                                                    onChange={ handleProperNounsFilterOptionChange} />
                                                { properNounsFilterActive && properNounsFilterOption == 'gender' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'propernouns-gender-fem' }
                                                                label={ t("Feminine proper nouns") + ' (' + nlpCategories.properNounsGenderFem + ')' }
                                                                onChange={ handleProperNounsFilterOptionChange }
                                                                checked={ properNounsGenderChecked.fem } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'propernouns-gender-masc' }
                                                                label={ t("Masculine proper nouns") + ' (' + nlpCategories.properNounsGenderMasc + ')' }
                                                                onChange={ handleProperNounsFilterOptionChange }
                                                                checked={ properNounsGenderChecked.masc } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'propernouns-gender-neut' }
                                                                label={ t("Neuter proper nouns") + ' (' + nlpCategories.properNounsGenderNeut + ')' }
                                                                onChange={ handleProperNounsFilterOptionChange }
                                                                checked={ properNounsGenderChecked.neut } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'propernouns-animacy' } name={ 'propernouns' }
                                                    label={ t("Animacy") } value={ 'animacy' }
                                                    onChange={ handleProperNounsFilterOptionChange} />
                                                { properNounsFilterActive && properNounsFilterOption == 'animacy' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'propernouns-animacy-anim' }
                                                                label={ t("Animate proper nouns") + ' (' + nlpCategories.properNounsAnimacyAnim + ')' }
                                                                onChange={ handleProperNounsFilterOptionChange }
                                                                checked={ properNounsAnimacyChecked.anim } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'propernouns-animacy-inan' }
                                                                label={ t("Inanimate proper nouns") + ' (' + nlpCategories.properNounsAnimacyInan + ')' }
                                                                onChange={ handleProperNounsFilterOptionChange }
                                                                checked={ properNounsAnimacyChecked.inan } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'propernouns-number' } name={ 'propernouns' }
                                                    label={ t("Number") } value={ 'number' }
                                                    onChange={ handleProperNounsFilterOptionChange} />
                                                { properNounsFilterActive && properNounsFilterOption == 'number' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'propernouns-number-sing' }
                                                                label={ t("Singular proper nouns") + ' (' + nlpCategories.properNounsNumberSing + ')' }
                                                                onChange={ handleProperNounsFilterOptionChange }
                                                                checked={ properNounsNumberChecked.sing } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'propernouns-number-plur' }
                                                                label={ t("Plural proper nouns") + ' (' + nlpCategories.properNounsNumberPlur + ')' }
                                                                onChange={ handleProperNounsFilterOptionChange }
                                                                checked={ properNounsNumberChecked.plur } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'propernouns-case' } name={ 'propernouns' }
                                                    label={ t("Case") } value={ 'case' }
                                                    onChange={ handleProperNounsFilterOptionChange} />
                                                { properNounsFilterActive && properNounsFilterOption == 'case' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'propernouns-case-nom' }
                                                                label={ t("Nominative case") + ' (' + nlpCategories.properNounsCaseNom + ')' }
                                                                onChange={ handleProperNounsFilterOptionChange }
                                                                checked={ properNounsCaseChecked.nom } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'propernouns-case-gen' }
                                                                label={ t("Genitive case") + ' (' + nlpCategories.properNounsCaseGen + ')' }
                                                                onChange={ handleProperNounsFilterOptionChange }
                                                                checked={ properNounsCaseChecked.gen } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'propernouns-case-acc' }
                                                                label={ t("Accusative case") + ' (' + nlpCategories.properNounsCaseAcc + ')' }
                                                                onChange={ handleProperNounsFilterOptionChange }
                                                                checked={ properNounsCaseChecked.acc } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'propernouns-case-dat' }
                                                                label={ t("Dative case") + ' (' + nlpCategories.properNounsCaseDat + ')' }
                                                                onChange={ handleProperNounsFilterOptionChange }
                                                                checked={ properNounsCaseChecked.dat } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'propernouns-case-ins' }
                                                                label={ t("Instrumental case") + ' (' + nlpCategories.properNounsCaseIns + ')' }
                                                                onChange={ handleProperNounsFilterOptionChange }
                                                                checked={ properNounsCaseChecked.ins } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'propernouns-case-loc' }
                                                                label={ t("Prepositional case") + ' (' + nlpCategories.properNounsCaseLoc + ')' }
                                                                onChange={ handleProperNounsFilterOptionChange }
                                                                checked={ properNounsCaseChecked.loc } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                                {/* Pronouns (PRON) - moved before Adjectives */}
                                <div className="word-category">
                                    <div className="option-item">
                                        <div className={ 'word-category-switch' + (pronounsFilterActive ? ' active' : '')}>
                                            <Form.Check type={ 'checkbox' } id={ 'pronouns' } label={ t("Pronouns") + ' (' + nlpCategories.pronounsAll + ')' }
                                                onChange={ handlePronounsFilterChange } checked={ pronounsFilterActive } />
                                        </div>
                                        { pronounsFilterActive &&
                                            <div className="options">
                                                <div className="format-options">
                                                    { colorOptions('pronoun', pronounsColor) }
                                                    { sizeOptions('pronoun', pronounsSize) }
                                                    <div className="other-formats">
                                                        <span className={ 'bold' + (nounsBold ? ' active' : '') }
                                                            data-element="pronoun" onClick={ setBold }></span>
                                                        <span className={ 'italic' + (nounsItalic ? ' active' : '') }
                                                            data-element="pronoun" onClick={ setItalic }></span>
                                                        <span className={ 'underline' + (nounsUnderline ? ' active' : '') }
                                                            data-element="pronoun" onClick={ setUnderline }></span>
                                                    </div>
                                                </div>
                                                <div className="option-item">
                                                    <Form.Check type={ 'radio' } id={ 'pronouns-all' } name={ 'pronouns' }
                                                        label={ t("All pronouns") } value={ 'all' } defaultChecked={ true }
                                                        onChange={ handlePronounsFilterOptionChange } />
                                                </div>

                                                <div className="option-item">
                                                    <Form.Check type={ 'radio' } id={ 'pronouns-gender' } name={ 'pronouns' }
                                                        label={ t("Gender") } value={ 'gender' }
                                                        onChange={ handlePronounsFilterOptionChange } />
                                                    { pronounsFilterActive && pronounsFilterOption == 'gender' &&
                                                        <div className="suboptions">
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-gender-fem' }
                                                                    label={ t("Feminine pronouns") + ' (' + nlpCategories.pronounsGenderFem + ')' }
                                                                    checked={ pronounsGenderChecked.fem }
                                                                    onChange={ handlePronounsFilterOptionChange } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-gender-masc' }
                                                                    label={ t("Masculine pronouns") + ' (' + nlpCategories.pronounsGenderMasc + ')' }
                                                                    checked={ pronounsGenderChecked.masc }
                                                                    onChange={ handlePronounsFilterOptionChange } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-gender-neut' }
                                                                    label={ t("Neuter pronouns") + ' (' + nlpCategories.pronounsGenderNeut + ')' }
                                                                    checked={ pronounsGenderChecked.neut }
                                                                    onChange={ handlePronounsFilterOptionChange } />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>

                                                <div className="option-item">
                                                    <Form.Check type={ 'radio' } id={ 'pronouns-animacy' } name={ 'pronouns' }
                                                        label={ t("Animacy") } value={ 'animacy' }
                                                        onChange={ handlePronounsFilterOptionChange } />
                                                    { pronounsFilterActive && pronounsFilterOption == 'animacy' &&
                                                        <div className="suboptions">
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-animacy-anim' }
                                                                    label={ t("Animate pronouns") + ' (' + nlpCategories.pronounsAnimacyAnim + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange }
                                                                    checked={ pronounsAnimacyChecked.anim } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-animacy-inan' }
                                                                    label={ t("Inanimate pronouns") + ' (' + nlpCategories.pronounsAnimacyInan + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange }
                                                                    checked={ pronounsAnimacyChecked.inan } />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>

                                                <div className="option-item">
                                                    <Form.Check type={ 'radio' } id={ 'pronouns-number' } name={ 'pronouns' }
                                                        label={ t("Number") } value={ 'number' }
                                                        onChange={ handlePronounsFilterOptionChange } />
                                                    { pronounsFilterActive && pronounsFilterOption == 'number' &&
                                                        <div className="suboptions">
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-number-sing' }
                                                                    label={ t("Singular pronouns") + ' (' + nlpCategories.pronounsNumberSing + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange }
                                                                    checked={ pronounsNumberChecked.sing } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-number-plur' }
                                                                    label={ t("Plural pronouns") + ' (' + nlpCategories.pronounsNumberPlur + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange }
                                                                    checked={ pronounsNumberChecked.plur } />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>

                                                <div className="option-item">
                                                    <Form.Check type={ 'radio' } id={ 'pronouns-case' } name={ 'pronouns' }
                                                        label={ t("Case") } value={ 'case' }
                                                        onChange={ handlePronounsFilterOptionChange } />
                                                    { pronounsFilterActive && pronounsFilterOption == 'case' &&
                                                        <div className="suboptions">
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-case-nom' }
                                                                    label={ t("Nominative case") + ' (' + nlpCategories.pronounsCaseNom + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange }
                                                                    checked={ pronounsCaseChecked.nom } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-case-gen' }
                                                                    label={ t("Genitive case") + ' (' + nlpCategories.pronounsCaseGen + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange }
                                                                    checked={ pronounsCaseChecked.gen } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-case-acc' }
                                                                    label={ t("Accusative case") + ' (' + nlpCategories.pronounsCaseAcc + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange }
                                                                    checked={ pronounsCaseChecked.acc } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-case-dat' }
                                                                    label={ t("Dative case") + ' (' + nlpCategories.pronounsCaseDat + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange }
                                                                    checked={ pronounsCaseChecked.dat } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-case-ins' }
                                                                    label={ t("Instrumental case") + ' (' + nlpCategories.pronounsCaseIns + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange }
                                                                    checked={ pronounsCaseChecked.ins } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-case-loc' }
                                                                    label={ t("Prepositional case") + ' (' + nlpCategories.pronounsCaseLoc + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange }
                                                                    checked={ pronounsCaseChecked.loc } />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>

                                                <div className="option-item">
                                                    <Form.Check type={ 'radio' } id={ 'pronouns-person' } name={ 'pronouns' }
                                                        label={ t("Person") } value={ 'person' }
                                                        onChange={ handlePronounsFilterOptionChange } />
                                                    { pronounsFilterActive && pronounsFilterOption == 'person' &&
                                                        <div className="suboptions">
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-person-1' }
                                                                    label={ t("First person pronouns") + ' (' + nlpCategories.pronounsPerson1 + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange }
                                                                    checked={ pronounsPersonChecked.first } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-person-2' }
                                                                    label={ t("Second person pronouns") + ' (' + nlpCategories.pronounsPerson2 + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange }
                                                                    checked={ pronounsPersonChecked.second } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-person-3' }
                                                                    label={ t("Third person pronouns") + ' (' + nlpCategories.pronounsPerson3 + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange }
                                                                    checked={ pronounsPersonChecked.third } />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>

                                                <div className="option-item">
                                                    <Form.Check type={ 'radio' } id={ 'pronouns-prontype' } name={ 'pronouns' }
                                                        label={ t("Pronoun Type") } value={ 'prontype' }
                                                        onChange={ handlePronounsFilterOptionChange } />
                                                    { pronounsFilterActive && pronounsFilterOption == 'prontype' &&
                                                        <div className="suboptions">
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-prontype-prs' }
                                                                    label={ t("Personal pronouns") + ' (' + nlpCategories.pronounsPronTypePrs + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange }
                                                                    checked={ pronounsPronTypeChecked.prs } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-prontype-ind' }
                                                                    label={ t("Indefinite pronouns") + ' (' + nlpCategories.pronounsPronTypeInd + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange }
                                                                    checked={ pronounsPronTypeChecked.ind } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-prontype-dem' }
                                                                    label={ t("Demonstrative pronouns") + ' (' + nlpCategories.pronounsPronTypeDem + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange }
                                                                    checked={ pronounsPronTypeChecked.dem } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-prontype-int-rel' }
                                                                    label={ t("Interrogative/Relative pronouns") + ' (' + nlpCategories.pronounsPronTypeIntRel + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'pronouns-prontype-tot' }
                                                                    label={ t("Total pronouns") + ' (' + nlpCategories.pronounsPronTypeTot + ')' }
                                                                    onChange={ handlePronounsFilterOptionChange } />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (adjectivesFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'adjectives' } label={ t("Adjectives") + ' (' + nlpCategories.adjectivesAll + ')' }
                                            onChange={ handleAdjectivesFilterChange } checked={ adjectivesFilterActive }/>
                                    </div>
                                    { adjectivesFilterActive && 
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('adjective', adjectivesColor) }
                                                { sizeOptions('adjective', adjectivesSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (adjectivesBold ? ' active' : '') }
                                                        data-element="adjective" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (adjectivesItalic ? ' active' : '') }
                                                        data-element="adjective" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (adjectivesUnderline ? ' active' : '') }
                                                        data-element="adjective" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'adjectives-all' } name={ 'adjectives' }
                                                    label={ t("All adjectives") + ' (' + nlpCategories.adjectivesAll + ')' } value={ 'all' } defaultChecked={ true }
                                                    onChange={ handleAdjectivesFilterOptionChange } />
                                            </div>

                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'adjectives-gender' } name={ 'adjectives' }
                                                    label={ t("Gender") } value={ 'gender' }
                                                    onChange={ handleAdjectivesFilterOptionChange } />
                                                { adjectivesFilterActive && adjectivesFilterOption == 'gender' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adjectives-gender-fem' }
                                                                label={ t("Feminine adjectives") + ' (' + nlpCategories.adjectivesGenderFem + ')' }
                                                                checked={ adjectivesGenderChecked.fem }
                                                                onChange={ handleAdjectivesFilterOptionChange } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adjectives-gender-masc' }
                                                                label={ t("Masculine adjectives") + ' (' + nlpCategories.adjectivesGenderMasc + ')' }
                                                                checked={ adjectivesGenderChecked.masc }
                                                                onChange={ handleAdjectivesFilterOptionChange } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adjectives-gender-neut' }
                                                                label={ t("Neuter adjectives") + ' (' + nlpCategories.adjectivesGenderNeut + ')' }
                                                                checked={ adjectivesGenderChecked.neut }
                                                                onChange={ handleAdjectivesFilterOptionChange } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>

                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'adjectives-animacy' } name={ 'adjectives' }
                                                    label={ t("Animacy") } value={ 'animacy' }
                                                    onChange={ handleAdjectivesFilterOptionChange } />
                                                { adjectivesFilterActive && adjectivesFilterOption == 'animacy' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adjectives-animacy-anim' }
                                                                label={ t("Animate adjectives") + ' (' + nlpCategories.adjectivesAnimacyAnim + ')' }
                                                                onChange={ handleAdjectivesFilterOptionChange }
                                                                checked={ adjectivesAnimacyChecked.anim } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adjectives-animacy-inan' }
                                                                label={ t("Inanimate adjectives") + ' (' + nlpCategories.adjectivesAnimacyInan + ')' }
                                                                onChange={ handleAdjectivesFilterOptionChange }
                                                                checked={ adjectivesAnimacyChecked.inan } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>

                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'adjectives-number' } name={ 'adjectives' }
                                                    label={ t("Number") } value={ 'number' }
                                                    onChange={ handleAdjectivesFilterOptionChange } />
                                                { adjectivesFilterActive && adjectivesFilterOption == 'number' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adjectives-number-sing' }
                                                                label={ t("Singular adjectives") + ' (' + nlpCategories.adjectivesNumberSing + ')' }
                                                                onChange={ handleAdjectivesFilterOptionChange }
                                                                checked={ adjectivesNumberChecked.sing } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adjectives-number-plur' }
                                                                label={ t("Plural adjectives") + ' (' + nlpCategories.adjectivesNumberPlur + ')' }
                                                                onChange={ handleAdjectivesFilterOptionChange }
                                                                checked={ adjectivesNumberChecked.plur } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>

                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'adjectives-case' } name={ 'adjectives' }
                                                    label={ t("Case") } value={ 'case' }
                                                    onChange={ handleAdjectivesFilterOptionChange } />
                                                { adjectivesFilterActive && adjectivesFilterOption == 'case' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adjectives-case-nom' }
                                                                label={ t("Nominative case") + ' (' + nlpCategories.adjectivesCaseNom + ')' }
                                                                onChange={ handleAdjectivesFilterOptionChange }
                                                                checked={ adjectivesCaseChecked.nom } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adjectives-case-gen' }
                                                                label={ t("Genitive case") + ' (' + nlpCategories.adjectivesCaseGen + ')' }
                                                                onChange={ handleAdjectivesFilterOptionChange }
                                                                checked={ adjectivesCaseChecked.gen } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adjectives-case-acc' }
                                                                label={ t("Accusative case") + ' (' + nlpCategories.adjectivesCaseAcc + ')' }
                                                                onChange={ handleAdjectivesFilterOptionChange }
                                                                checked={ adjectivesCaseChecked.acc } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adjectives-case-dat' }
                                                                label={ t("Dative case") + ' (' + nlpCategories.adjectivesCaseDat + ')' }
                                                                onChange={ handleAdjectivesFilterOptionChange }
                                                                checked={ adjectivesCaseChecked.dat } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adjectives-case-ins' }
                                                                label={ t("Instrumental case") + ' (' + nlpCategories.adjectivesCaseIns + ')' }
                                                                onChange={ handleAdjectivesFilterOptionChange }
                                                                checked={ adjectivesCaseChecked.ins } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adjectives-case-loc' }
                                                                label={ t("Prepositional case") + ' (' + nlpCategories.adjectivesCaseLoc + ')' }
                                                                onChange={ handleAdjectivesFilterOptionChange }
                                                                checked={ adjectivesCaseChecked.loc } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>

                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'adjectives-degree' } name={ 'adjectives' }
                                                    label={ t("Degree") } value={ 'degree' }
                                                    onChange={ handleAdjectivesFilterOptionChange } />
                                                { adjectivesFilterActive && adjectivesFilterOption == 'degree' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adjectives-degree-pos' }
                                                                label={ t("Positive degree") + ' (' + nlpCategories.adjectivesPositive + ')' }
                                                                onChange={ handleAdjectivesFilterOptionChange }
                                                                checked={ adjectivesDegreeChecked.pos } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adjectives-degree-cmp' }
                                                                label={ t("Comparative degree") + ' (' + nlpCategories.adjectivesComparative + ')' }
                                                                onChange={ handleAdjectivesFilterOptionChange }
                                                                checked={ adjectivesDegreeChecked.cmp } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adjectives-degree-sup' }
                                                                label={ t("Superlative degree") + ' (' + nlpCategories.adjectivesSuperlative + ')' }
                                                                onChange={ handleAdjectivesFilterOptionChange }
                                                                checked={ adjectivesDegreeChecked.sup } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>

                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'adjectives-form' } name={ 'adjectives' }
                                                    label={ t("Form") } value={ 'form' }
                                                    onChange={ handleAdjectivesFilterOptionChange } />
                                                { adjectivesFilterActive && adjectivesFilterOption == 'form' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adjectives-form-short' }
                                                                label={ t("Short Form") + ' (' + nlpCategories.adjectivesFormShort + ')' }
                                                                onChange={ handleAdjectivesFilterOptionChange }
                                                                checked={ adjectivesFormChecked.short } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (numeralsFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'numerals' } label={ t("Numerals") + ' (' + nlpCategories.numeralsAll + ')' }
                                            onChange={ handleNumeralsFilterChange } checked={ numeralsFilterActive } />
                                    </div>
                                    { numeralsFilterActive &&
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('numeral', numeralsColor) }
                                                { sizeOptions('numeral', numeralsSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (numeralsBold ? ' active' : '') }
                                                        data-element="numeral" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (numeralsItalic ? ' active' : '') }
                                                        data-element="numeral" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (numeralsUnderline ? ' active' : '') }
                                                        data-element="numeral" onClick={ setUnderline }></span>
                                                </div>
                                            </div>

                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'numerals-all' } name={ 'numerals' }
                                                    label={ t("All numerals") + ' (' + nlpCategories.numeralsAll + ')' } value={ 'all' } defaultChecked={ true }
                                                    onChange={ handleNumeralsFilterOptionChange } />
                                            </div>

                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'numerals-gender' } name={ 'numerals' }
                                                    label={ t("Gender") } value={ 'gender' }
                                                    onChange={ handleNumeralsFilterOptionChange } />
                                                { numeralsFilterActive && numeralsFilterOption == 'gender' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'numerals-gender-fem' }
                                                                label={ t("Feminine numerals") + ' (' + nlpCategories.numeralsGenderFem + ')' }
                                                                onChange={ handleNumeralsFilterOptionChange }
                                                                checked={ numeralsGenderChecked.fem } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'numerals-gender-masc' }
                                                                label={ t("Masculine numerals") + ' (' + nlpCategories.numeralsGenderMasc + ')' }
                                                                onChange={ handleNumeralsFilterOptionChange }
                                                                checked={ numeralsGenderChecked.masc } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'numerals-gender-neut' }
                                                                label={ t("Neuter numerals") + ' (' + nlpCategories.numeralsGenderNeut + ')' }
                                                                onChange={ handleNumeralsFilterOptionChange }
                                                                checked={ numeralsGenderChecked.neut } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>

                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'numerals-number' } name={ 'numerals' }
                                                    label={ t("Number") } value={ 'number' }
                                                    onChange={ handleNumeralsFilterOptionChange } />
                                                { numeralsFilterActive && numeralsFilterOption == 'number' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'numerals-number-sing' }
                                                                label={ t("Singular numerals") + ' (' + nlpCategories.numeralsNumberSing + ')' }
                                                                onChange={ handleNumeralsFilterOptionChange }
                                                                checked={ numeralsNumberChecked.sing } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'numerals-number-plur' }
                                                                label={ t("Plural numerals") + ' (' + nlpCategories.numeralsNumberPlur + ')' }
                                                                onChange={ handleNumeralsFilterOptionChange }
                                                                checked={ numeralsNumberChecked.plur } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>

                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'numerals-case' } name={ 'numerals' }
                                                    label={ t("Case") } value={ 'case' }
                                                    onChange={ handleNumeralsFilterOptionChange } />
                                                { numeralsFilterActive && numeralsFilterOption == 'case' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'numerals-case-nom' }
                                                                label={ t("Nominative case") + ' (' + nlpCategories.numeralsCaseNom + ')' }
                                                                onChange={ handleNumeralsFilterOptionChange }
                                                                checked={ numeralsCaseChecked.nom } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'numerals-case-gen' }
                                                                label={ t("Genitive case") + ' (' + nlpCategories.numeralsCaseGen + ')' }
                                                                onChange={ handleNumeralsFilterOptionChange }
                                                                checked={ numeralsCaseChecked.gen } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'numerals-case-acc' }
                                                                label={ t("Accusative case") + ' (' + nlpCategories.numeralsCaseAcc + ')' }
                                                                onChange={ handleNumeralsFilterOptionChange }
                                                                checked={ numeralsCaseChecked.acc } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'numerals-case-dat' }
                                                                label={ t("Dative case") + ' (' + nlpCategories.numeralsCaseDat + ')' }
                                                                onChange={ handleNumeralsFilterOptionChange }
                                                                checked={ numeralsCaseChecked.dat } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'numerals-case-ins' }
                                                                label={ t("Instrumental case") + ' (' + nlpCategories.numeralsCaseIns + ')' }
                                                                onChange={ handleNumeralsFilterOptionChange }
                                                                checked={ numeralsCaseChecked.ins } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'numerals-case-loc' }
                                                                label={ t("Prepositional case") + ' (' + nlpCategories.numeralsCaseLoc + ')' }
                                                                onChange={ handleNumeralsFilterOptionChange }
                                                                checked={ numeralsCaseChecked.loc } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>

                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'numerals-numtype' } name={ 'numerals' }
                                                    label={ t("Number Type") } value={ 'numtype' }
                                                    onChange={ handleNumeralsFilterOptionChange } />
                                                { numeralsFilterActive && numeralsFilterOption == 'numtype' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'numerals-numtype-card' }
                                                                label={ t("Cardinal numbers") + ' (' + nlpCategories.numeralsNumTypeCard + ')' }
                                                                onChange={ handleNumeralsFilterOptionChange }
                                                                checked={ numeralsNumTypeChecked.card } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (adverbsFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'adverbs' } label={ t("Adverbs") + ' (' + nlpCategories.adverbsAll + ')' }
                                            onChange={ handleAdverbsFilterChange } checked={ adverbsFilterActive }/>
                                    </div>
                                    { adverbsFilterActive && 
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('adverb', adverbsColor) }
                                                { sizeOptions('adverb', adverbsSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (adverbsBold ? ' active' : '') }
                                                        data-element="adverb" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (adverbsItalic ? ' active' : '') }
                                                        data-element="adverb" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (adverbsUnderline ? ' active' : '') }
                                                        data-element="adverb" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'adverbs-all' } name={ 'adverbs' }
                                                    label={ t("All adverbs") + ' (' + nlpCategories.adverbsAll + ')' } value={ 'all' } defaultChecked={ true }
                                                    onChange={ handleAdverbsFilterOptionChange } />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'adverbs-degree' } name={ 'adverbs' }
                                                    label={ t("Degree") } value={ 'degree' }
                                                    onChange={ handleAdverbsFilterOptionChange } />
                                                { adverbsFilterActive && adverbsFilterOption == 'degree' &&
                                                    <div className="suboptions">
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adverbs-degree-cmp' }
                                                                label={ t("Comparative degree") + ' (' + nlpCategories.adverbsComparative + ')' }
                                                                onChange={ handleAdverbsFilterOptionChange }
                                                                checked={ adverbsDegreeChecked.cmp } />
                                                        </div>
                                                        <div className="suboption-item">
                                                            <Form.Check type={ 'checkbox' } id={ 'adverbs-degree-sup' }
                                                                label={ t("Superlative degree") + ' (' + nlpCategories.adverbsSuperlative + ')' }
                                                                onChange={ handleAdverbsFilterOptionChange }
                                                                checked={ adverbsDegreeChecked.sup } />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (verbsFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'verbs' } label={ t("Verbs") + ' (' + nlpCategories.verbsAll + ')' }
                                            onChange={ handleVerbsFilterChange } checked={ verbsFilterActive }/>
                                    </div>
                                    { verbsFilterActive && 
                                            <div className="options">
                                                <div className="format-options">
                                                    { colorOptions('verb', verbsColor) }
                                                    { sizeOptions('verb', verbsSize) }
                                                    <div className="other-formats">
                                                        <span className={ 'bold' + (verbsBold ? ' active' : '') }
                                                            data-element="verb" onClick={ setBold }></span>
                                                        <span className={ 'italic' + (verbsItalic ? ' active' : '') }
                                                            data-element="verb" onClick={ setItalic }></span>
                                                        <span className={ 'underline' + (verbsUnderline ? ' active' : '') }
                                                            data-element="verb" onClick={ setUnderline }></span>
                                                    </div>
                                                </div>
                                                <div className="option-item">
                                                    <Form.Check type={ 'radio' } id={ 'verbs-all' } name={ 'verbs' }
                                                        label={ t("All verbs") + ' (' + nlpCategories.verbsAll + ')' } value={ 'all' } defaultChecked={ true }
                                                        onChange={ handleVerbsFilterOptionChange } />
                                                </div>
                                                <div className="option-item">
                                                    <Form.Check type={ 'radio' } id={ 'verbs-aspect' } name={ 'verbs' }
                                                        label={ t("Aspect") } value={ 'aspect' }
                                                        onChange={ handleVerbsFilterOptionChange } />
                                                    { verbsFilterActive && verbsFilterOption == 'aspect' &&
                                                        <div className="suboptions">
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-aspect-imp' }
                                                                    label={ t("Imperfective aspect") + ' (' + nlpCategories.verbsAspectImp + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsAspectChecked.imp } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-aspect-perf' }
                                                                    label={ t("Perfective aspect") + ' (' + nlpCategories.verbsAspectPerf + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsAspectChecked.perf } />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                                <div className="option-item">
                                                    <Form.Check type={ 'radio' } id={ 'verbs-mood' } name={ 'verbs' }
                                                        label={ t("Mood") } value={ 'mood' }
                                                        onChange={ handleVerbsFilterOptionChange } />
                                                    { verbsFilterActive && verbsFilterOption == 'mood' &&
                                                        <div className="suboptions">
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-mood-ind' }
                                                                    label={ t("Indicative mood") + ' (' + nlpCategories.verbsMoodInd + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsMoodChecked.ind } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-mood-cnd' }
                                                                    label={ t("Conditional mood") + ' (' + nlpCategories.verbsMoodCnd + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsMoodChecked.cnd } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-mood-imp' }
                                                                    label={ t("Imperative mood") + ' (' + nlpCategories.verbsMoodImp + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsMoodChecked.imp } />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                                <div className="option-item">
                                                    <Form.Check type={ 'radio' } id={ 'verbs-tense' } name={ 'verbs' }
                                                        label={ t("Tense") } value={ 'tense' }
                                                        onChange={ handleVerbsFilterOptionChange } />
                                                    { verbsFilterActive && verbsFilterOption == 'tense' &&
                                                        <div className="suboptions">
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-tense-past' }
                                                                    label={ t("Past tense") + ' (' + nlpCategories.verbsTensePast + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsTenseChecked.past } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-tense-pres' }
                                                                    label={ t("Present tense") + ' (' + nlpCategories.verbsTensePres + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsTenseChecked.pres } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-tense-fut' }
                                                                    label={ t("Future tense") + ' (' + nlpCategories.verbsTenseFut + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsTenseChecked.fut } />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                                <div className="option-item">
                                                    <Form.Check type={ 'radio' } id={ 'verbs-gender' } name={ 'verbs' }
                                                        label={ t("Gender") } value={ 'gender' }
                                                        onChange={ handleVerbsFilterOptionChange } />
                                                    { verbsFilterActive && verbsFilterOption == 'gender' &&
                                                        <div className="suboptions">
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-gender-fem' }
                                                                    label={ t("Feminine verbs") + ' (' + nlpCategories.verbsGenderFem + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsGenderChecked.fem } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-gender-masc' }
                                                                    label={ t("Masculine verbs") + ' (' + nlpCategories.verbsGenderMasc + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsGenderChecked.masc } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-gender-neut' }
                                                                    label={ t("Neuter verbs") + ' (' + nlpCategories.verbsGenderNeut + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsGenderChecked.neut } />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                                <div className="option-item">
                                                    <Form.Check type={ 'radio' } id={ 'verbs-number' } name={ 'verbs' }
                                                        label={ t("Number") } value={ 'number' }
                                                        onChange={ handleVerbsFilterOptionChange } />
                                                    { verbsFilterActive && verbsFilterOption == 'number' &&
                                                        <div className="suboptions">
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-number-sing' }
                                                                    label={ t("Singular verbs") + ' (' + nlpCategories.verbsNumberSing + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsNumberChecked.sing } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-number-plur' }
                                                                    label={ t("Plural verbs") + ' (' + nlpCategories.verbsNumberPlur + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsNumberChecked.plur } />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                                <div className="option-item">
                                                    <Form.Check type={ 'radio' } id={ 'verbs-person' } name={ 'verbs' }
                                                        label={ t("Person") } value={ 'person' }
                                                        onChange={ handleVerbsFilterOptionChange } />
                                                    { verbsFilterActive && verbsFilterOption == 'person' &&
                                                        <div className="suboptions">
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-person-first' }
                                                                    label={ t("First person verbs") + ' (' + nlpCategories.verbsPerson1 + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsPersonChecked.first } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-person-second' }
                                                                    label={ t("Second person verbs") + ' (' + nlpCategories.verbsPerson2 + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsPersonChecked.second } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-person-third' }
                                                                    label={ t("Third person verbs") + ' (' + nlpCategories.verbsPerson3 + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsPersonChecked.third } />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                                <div className="option-item">
                                                    <Form.Check type={ 'radio' } id={ 'verbs-verbform' } name={ 'verbs' }
                                                        label={ t("VerbForm") } value={ 'verbform' }
                                                        onChange={ handleVerbsFilterOptionChange } />
                                                    { verbsFilterActive && verbsFilterOption == 'verbform' &&
                                                        <div className="suboptions">
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-verbform-fin' }
                                                                    label={ t("Finite verbs") + ' (' + nlpCategories.verbsVerbFormFin + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsVerbFormChecked.fin } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-verbform-inf' }
                                                                    label={ t("Infinitive verbs") + ' (' + nlpCategories.verbsVerbFormInf + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsVerbFormChecked.inf } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-verbform-conv' }
                                                                    label={ t("Converb verbs") + ' (' + nlpCategories.verbsVerbFormConv + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsVerbFormChecked.conv } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-verbform-part' }
                                                                    label={ t("Participle verbs") + ' (' + nlpCategories.verbsVerbFormPart + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsVerbFormChecked.part } />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                                <div className="option-item">
                                                    <Form.Check type={ 'radio' } id={ 'verbs-voice' } name={ 'verbs' }
                                                        label={ t("Voice") } value={ 'voice' }
                                                        onChange={ handleVerbsFilterOptionChange } />
                                                    { verbsFilterActive && verbsFilterOption == 'voice' &&
                                                        <div className="suboptions">
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-voice-act' }
                                                                    label={ t("Active voice") + ' (' + nlpCategories.verbsVoiceAct + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsVoiceChecked.act } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-voice-mid' }
                                                                    label={ t("Middle voice") + ' (' + nlpCategories.verbsVoiceMid + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsVoiceChecked.mid } />
                                                            </div>
                                                            <div className="suboption-item">
                                                                <Form.Check type={ 'checkbox' } id={ 'verbs-voice-pass' }
                                                                    label={ t("Passive voice") + ' (' + nlpCategories.verbsVoicePass + ')' }
                                                                    onChange={ handleVerbsFilterOptionChange }
                                                                    checked={ verbsVoiceChecked.pass } />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                </div>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (prepositionsFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'prepositions' } label={ t("Prepositions") + ' (' + nlpCategories.prepositionsAll + ')' }
                                            onChange={ handlePrepositionsFilterChange } checked={ prepositionsFilterActive }/>
                                    </div>
                                    { prepositionsFilterActive &&
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('preposition', prepositionsColor) }
                                                { sizeOptions('preposition', prepositionsSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (prepositionsBold ? ' active' : '') }
                                                        data-element="preposition" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (prepositionsItalic ? ' active' : '') }
                                                        data-element="preposition" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (prepositionsUnderline ? ' active' : '') }
                                                        data-element="preposition" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'prepositions-all' } name={ 'prepositions' }
                                                    label={ t("All prepositions") + ' (' + nlpCategories.prepositionsAll + ')' } value={ 'all' } defaultChecked={ true }
                                                    onChange={ handlePrepositionsFilterOptionChange } />
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (particlesFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'particles' } label={ t("Particles") + ' (' + nlpCategories.particlesAll + ')' }
                                            onChange={ handleParticlesFilterChange } checked={ particlesFilterActive }/>
                                    </div>
                                    { particlesFilterActive &&
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('particles', particlesColor) }
                                                { sizeOptions('particles', particlesSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (particlesBold ? ' active' : '') }
                                                        data-element="particles" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (particlesItalic ? ' active' : '') }
                                                        data-element="particles" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (particlesUnderline ? ' active' : '') }
                                                        data-element="particles" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'particles-all' } name={ 'particles' }
                                                    label={ t("All particles") + ' (' + nlpCategories.particlesAll + ')' } value={ 'all' } defaultChecked={ true }
                                                    onChange={ handleParticlesFilterOptionChange } />
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (conjunctionsFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'conjunctions' } label={ t("Coordinating Conjunctions") + ' (' + nlpCategories.conjunctionsAll + ')' }
                                            onChange={ handleConjunctionsFilterChange } checked={ conjunctionsFilterActive }/>
                                    </div>
                                    { conjunctionsFilterActive &&
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('conjunctions', conjunctionsColor) }
                                                { sizeOptions('conjunctions', conjunctionsSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (conjunctionsBold ? ' active' : '') }
                                                        data-element="conjunctions" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (conjunctionsItalic ? ' active' : '') }
                                                        data-element="conjunctions" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (conjunctionsUnderline ? ' active' : '') }
                                                        data-element="conjunctions" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'conjunctions-all' } name={ 'conjunctions' }
                                                    label={ t("All coordinating conjunctions") + ' (' + nlpCategories.conjunctionsAll + ')' } value={ 'all' } defaultChecked={ true }
                                                    onChange={ handleConjunctionsFilterOptionChange } />
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (subConjunctionsFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'subConjunctions' } label={ t("Subordinating conjunctions") + ' (' + nlpCategories.subConjunctionsAll + ')' }
                                            onChange={ handleSubConjunctionsFilterChange } checked={ subConjunctionsFilterActive }/>
                                    </div>
                                    { subConjunctionsFilterActive &&
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('subConjunction', subConjunctionsColor) }
                                                { sizeOptions('subConjunction', subConjunctionsSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (subConjunctionsBold ? ' active' : '') }
                                                        data-element="subConjunction" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (subConjunctionsItalic ? ' active' : '') }
                                                        data-element="subConjunction" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (subConjunctionsUnderline ? ' active' : '') }
                                                        data-element="subConjunction" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'subconjunctions-all' } name={ 'subconjunctions' }
                                                    label={ t("All subordinating conjunctions") + ' (' + nlpCategories.subConjunctionsAll + ')' } value={ 'all' } defaultChecked={ true }
                                                    onChange={ handleSubConjunctionsFilterOptionChange } />
                                            </div>
                                        </div>
                                    }
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            }
            <div className="text-presentation">
                <div className="text-formatted">
                    { parse(allText)}
                </div>
            </div>
        </div>
    );
}